import React, { useEffect, useState, useContext, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider"
import Header from "../../Components/Header";
import { RetrieveSelectedPlan } from "../../Services/InsuranceApi";
import { CreatePolicy } from "../../Services/InsuranceApi";
import { RetrieveCorporateDetails } from "../../Services/API";
import { AddPassengerDetails } from "../../Services/InsuranceApi";
import { CollectPayment } from "../../Services/API";
import { TravelPolicies } from "../../Services/API";
import { ApprovalPolicy } from "../../Services/ApprovalAPI";
import { ApprovalRequest } from "../../Services/ApprovalAPI";

const InsBooking = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const { name, userName, roles, corporateId } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [travellerData, setTravellerData] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState("");
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [paymentError, setPaymentError] = useState("");
    const [termsError, setTermsError] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [agencyDetails, setAgencyDetails] = useState(null);
    const [totalFare, setTotalFare] = useState(0);
    const [contactDetails, setContactDetails] = useState({ emailId: "", countryCode: "", mobile: "", organizationType: "", gstNumber: "", gstName: "", emailOngst: "", phoneOnGst: "", addressOnGst: "" });
    const [ageWisePremiums, setAgeWisePremiums] = useState([]);
    const [approvalPolicies, setApprovalPolicies] = useState([]);
    const [policyData, setPolicyData] = useState(null);
    //ageWisePremiums
    // Next Step
    const nextStep = () => {
        if (step < 4) {
            setStep(step + 1);
        }
    };

    // Previous Step
    const prevStep = () => {
        if (step > 1) {
            setStep(step - 1);
        }
    };
    const [addonsAmount, setAddonsAmount] = useState(0);

    // Dynamic Reference Number
    const [bookingData, setBookingData] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    debugger;
    const ages = bookingData?.selectedInsurance?.age || [];
    //const premium = bookingData?.selectedInsurance?.plan?.agePremiums

    // const [travellers, setTravellers] = useState([]);
    const [travellers, setTravellers] = useState(
        ages.map(() => ({
            passportNumber: "",
            title: "",
            firstName: "",
            lastName: "",
            dob: "",
            age: "",
            mobileNo: "",
            email: "",
            city: "",
            district: "",
            pincode: "",
            state: "",
            address: "",
            country: "",
            nominee: "",
            relationship: "",
            medicalCondition: "",
            finalPremium: "",
            riderTotalAmt: "",
            pastillness: "No",
            remarks: "No",
            crReferenceNumber: "",
            emergencyContactPerson: "",
            emergencyContactNumber: "",
            emergencyEmailId: "",
            pnrNumber: "",
            univercityAddress: "",
            univercityName: "",
            flightNumber: "",
            departureTime: "",
            arrivalTime: "",
            departureAirportCode: "",
            arrivalAirportCode: ""
        }))
    );

    const queryParams = new URLSearchParams(location.search);

    function getParamIgnoreCase(key) {
        for (const [k, v] of queryParams.entries()) {
            if (k.toLowerCase() === key.toLowerCase()) {
                return v;
            }
        }
        return null;
    }

    const referenceNo = getParamIgnoreCase("ReferenceNo");
    const clientCode = getParamIgnoreCase("ClientCode");
    const key = getParamIgnoreCase("Key");

    const [tripType, setTripType] = useState("Domestic");
    const [policies, setPolicies] = useState([]);

    const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
    const userId = emulateCorporateCode || corporateId;
    const CorpTravellerUserId = localStorage.getItem("selectedUserId");
    const CorpTraveller = CorpTravellerUserId ?? userName;
    useEffect(() => {
        //debugger;
        if (!userName || !tripType || !userId || userId === "null" || userId === "undefined") return;
        const getTravelPolicies = async () => {
            try {
                const response = await TravelPolicies({
                    UserName: CorpTraveller,
                    ProductType: "Insurance",
                    CorporateCode: userId,
                    TravelType: tripType
                });

                setPolicies(response);
                console.log("getTravelPolicies", response);
            } catch (error) {
                console.error(error);
            }
        };
        getTravelPolicies();
    }, [userName, userId, tripType]);

    useEffect(() => {
        if (!userName || !tripType || !userId) return;
        const getApprovalPolicies = async () => {
            try {
                const response = await ApprovalPolicy({
                    UserName: CorpTraveller,
                    ProductType: "Insurance",
                    CorporateCode: userId,
                    TravelType: tripType
                });

                setApprovalPolicies(response);

                console.log("getApprovalPolicies", response);
            } catch (error) {
                console.error(error);
            }
        };

        getApprovalPolicies();
    }, [userName, userId, tripType]);

    useEffect(() => {
        //debugger;
        if (bookingData?.selectedInsurance?.age) {
            const pax = bookingData.selectedInsurance.age;

            setTravellers(
                pax.map((item, index) => ({
                    passportNumber: "",
                    title: "",
                    firstName: "",
                    lastName: "",
                    dob: "",
                    age: "",
                    mobileNo: "",
                    email: "",
                    city: "",
                    pincode: "",
                    state: "",
                    district: "",
                    address: "",
                    country: "",
                    nominee: "",
                    relationship: "",
                    medicalCondition: "",
                    finalPremium: "",
                    riderTotalAmt: "",
                    pastillness: "No",
                    remarks: "",
                    crReferenceNumber: "",
                    emergencyContactPerson: "",
                    emergencyContactNumber: "",
                    emergencyEmailId: "",
                    pnrNumber: "",
                    univercityAddress: "",
                    univercityName: "",
                    flightNumber: "",
                    departureTime: "",
                    arrivalTime: "",
                    departureAirportCode: "",
                    arrivalAirportCode: ""
                }))
            );
        }
    }, [bookingData]);


    useEffect(() => {
        const fetchBooking = async () => {
            try {
                const response = await RetrieveSelectedPlan(referenceNo);
                console.log("RETRIEVE SELECTED PLAN", response);
                if (response?.selectedInsurance?.category === "296a9n2f-3071-4395-g416-31d60fdf0d4e") {
                    setTripType("Domestic")
                } else {
                    setTripType("International")
                }
                setBookingData(response);
                const planData = response?.selectedInsurance?.plan;
                if (planData) {
                    try {
                        setSelectedPlan(
                            typeof planData === "string"
                                ? JSON.parse(planData)
                                : planData
                        );
                    } catch (e) {
                        console.error(
                            "Plan Parse Error",
                            e
                        );
                    }
                }

                const corporateCode = localStorage.getItem("selectedCorporateCode");
                const userId = localStorage.getItem("selectedUserId");
                const agentDetailsResponse = await RetrieveCorporateDetails(userName, corporateCode, userId);
                console.log("CorporateDetails:", agentDetailsResponse);
                setAgencyDetails(agentDetailsResponse.data);

                const phone = agentDetailsResponse.data.corporateDetails?.phoneNumber || "";
                let countryCode = "91";
                let mobile = "";

                if (phone.includes(" ")) {
                    [countryCode, mobile] = phone.split(" ");
                } else {
                    mobile = phone;
                }
                setContactDetails({
                    emailId: agentDetailsResponse.data.corporateDetails?.email || "",
                    countryCode,
                    mobile,
                    organizationType: agentDetailsResponse.data.corporateDetails?.companyType || "",
                    gstNumber: agentDetailsResponse.data.corporateDetails?.gstNumber || "",
                    gstName: agentDetailsResponse.data.corporateDetails?.gstName || "",
                    emailOngst: agentDetailsResponse.data.corporateDetails?.gstEmail || "",
                    phoneOnGst: agentDetailsResponse.data.corporateDetails?.gstContactNumber || "",
                    addressOnGst: agentDetailsResponse.data.corporateDetails?.gstAddress || "",
                });
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        if (referenceNo && key && clientCode) {
            fetchBooking();
        }
    }, [referenceNo, key, clientCode]);

    useEffect(() => {
        const policyStatus = bookingData?.selectedInsurance?.policyStatus;
        const policy = approvalPolicies?.approvalPolicy?.result?.find(
            item => item.policyStatus === policyStatus
        );

        setPolicyData(policy || null);
    }, [approvalPolicies, bookingData]);

    // total Amount start
    // const premium =
    //     Number(
    //         bookingData?.selectedInsurance
    //             ?.totalPremium
    //     ) || 0;

    const addonTotal =
        Number(addonsAmount) || 0;

    // const gst = 0;

    // const grandTotal =
    //     (
    //         premium +
    //         addonTotal +
    //         gst
    //     ).toFixed(2);
    // // total Amount end

    const premium =
        (selectedPlan?.agePremiums || []).reduce(
            (sum, item) =>
                sum + Number(item.premium || 0),
            0
        );

    const grandTotal =
        Number(premium) +
        Number(addonsAmount || 0);

    //setTotalFare(grandTotal);



    const [isSelected, setIsSelected] = useState(false);

    const [selectedRiders, setSelectedRiders] = useState([]);
    const [selectedRiderPremiums, setSelectedRiderPremiums] = useState([]);
    //const [addonsAmount, setAddonsAmount] = useState(0);

    const AddAmountExtra = (rider) => {
        const riderId = rider?.id;
        const premiums = Array.isArray(selectedPlan?.agePremiums)
            ? selectedPlan.agePremiums
            : [];

        const ageWiseRiderPremiums = premiums.map((item) => ({
            age: item.age,
            premium: Number(item.premium || 0),
            riderPremium:
                Number(rider?.premiumPercent || 0) > 0
                    ? (
                        Number(item.premium || 0) *
                        Number(rider.premiumPercent)
                    ) / 100
                    : Number(rider?.riderValue || 0),
        }));

        const riderAmount = ageWiseRiderPremiums.reduce(
            (sum, item) =>
                sum + Number(item.riderPremium || 0),
            0
        );

        const isAlreadySelected =
            selectedRiders.includes(riderId);

        if (isAlreadySelected) {
            setSelectedRiders((prev) =>
                prev.filter((id) => id !== riderId)
            );

            setSelectedRiderPremiums((prev) =>
                prev.filter((x) => x.riderId !== riderId)
            );

            setAddonsAmount((prev) =>
                Number(
                    (Number(prev) - riderAmount).toFixed(2)
                )
            );
        } else {
            setSelectedRiders((prev) => [
                ...prev,
                riderId,
            ]);

            setSelectedRiderPremiums((prev) => [
                ...prev,
                {
                    riderId,
                    riderName: rider.name,
                    premiums: ageWiseRiderPremiums,
                    totalPremium: riderAmount,
                },
            ]);

            setAddonsAmount((prev) =>
                Number(
                    (Number(prev) + riderAmount).toFixed(2)
                )
            );
        }

    };
    //console.log("selectedRiderPremiums",selectedRiderPremiums)

    // const AddAmountExtra = (rider) => {
    //     const riderId = rider?.id;

    //     // Ensure premiums is always an array
    //     const premiums = Array.isArray(selectedPlan?.premium)
    //         ? selectedPlan.premium
    //         : [];

    //     // Age-wise rider premiums
    //     const ageWiseRiderPremiums = premiums.map((item) => ({
    //         age: item.age,
    //         premium: Number(item.premium || 0),
    //         riderPremium:
    //             Number(rider?.premiumPercent || 0) > 0
    //                 ? (
    //                     Number(item.premium || 0) *
    //                     Number(rider.premiumPercent)
    //                 ) / 100
    //                 : Number(rider?.riderValue || 0),
    //     }));

    //     // Total rider amount
    //     const riderAmount = ageWiseRiderPremiums.reduce(
    //         (sum, item) => sum + Number(item.riderPremium || 0),
    //         0
    //     );

    //     const isAlreadySelected = selectedRiders.includes(riderId);

    //     if (isAlreadySelected) {
    //         // Remove rider
    //         setSelectedRiders((prev) =>
    //             prev.filter((id) => id !== riderId)
    //         );

    //         setSelectedRiderPremiums((prev) =>
    //             prev.filter((item) => item.riderId !== riderId)
    //         );

    //         setAddonsAmount((prev) =>
    //             Number((Number(prev) - riderAmount).toFixed(2))
    //         );
    //     } else {
    //         // Add rider
    //         setSelectedRiders((prev) => [...prev, riderId]);

    //         setSelectedRiderPremiums((prev) => [
    //             ...prev,
    //             {
    //                 riderId,
    //                 riderName: rider?.name,
    //                 premiums: ageWiseRiderPremiums,
    //             },
    //         ]);

    //         setAddonsAmount((prev) =>
    //             Number((Number(prev) + riderAmount).toFixed(2))
    //         );
    //     }

    //     console.log("Age Wise Rider Premiums:", ageWiseRiderPremiums);
    // };

    // const [selectedRiders, setSelectedRiders] = useState([]);

    // const AddAmountExtra = (rider) => {
    //     const riderId = rider?.id;

    //     const riderAmount =
    //         (
    //             (Number(selectedPlan?.premium || 0) *
    //                 Number(rider?.premiumPercent || 0)) /
    //             100
    //         );

    //     const isAlreadySelected =
    //         selectedRiders.includes(riderId);

    //     if (isAlreadySelected) {
    //         setSelectedRiders((prev) =>
    //             prev.filter((id) => id !== riderId)
    //         );

    //         setAddonsAmount((prev) =>
    //             (
    //                 Number(prev) - riderAmount
    //             ).toFixed(2)
    //         );
    //     } else {
    //         setSelectedRiders((prev) => [
    //             ...prev,
    //             riderId,
    //         ]);

    //         setAddonsAmount((prev) =>
    //             (
    //                 Number(prev) + riderAmount
    //             ).toFixed(2)
    //         );
    //     }
    // };

    const [passportNumber, setPassportNumber] = useState("");
    const [title, setTitle] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [dob, setDob] = useState("");
    const [age, setAge] = useState("");
    const [address, setAddress] = useState("");
    const [pincode, setPincode] = useState("");
    const [city, setCity] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [email, setEmail] = useState("");
    const [nominee, setNominee] = useState("");
    const [relationship, setRelationship] = useState("");
    const [medicalCondition, setMedicalCondition] = useState("");

    const [errors, setErrors] = useState({});

    const HandleFormSubmit = () => {
        let newErrors = {};

        travellers.forEach((traveller, index) => {
            const prefix = `traveller_${index}`;

            if (!contact.email.trim()) {
                newErrors.email =
                    "Enter Contact Email Address";
            } else if (
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                    contact.email
                )
            ) {
                newErrors.email =
                    "Enter Valid Contact Email Address";
            }

            if (!contact.phone.trim()) {
                newErrors.phone =
                    "Enter Contact Number";
            } else if (
                !/^[0-9]{10}$/.test(contact.phone)
            ) {
                newErrors.phone =
                    "Enter Valid Contact Number";
            }


            if (!traveller.title?.trim()) {
                newErrors[`${prefix}_title`] =
                    "Select Title";
            }

            if (!traveller.firstName?.trim()) {
                newErrors[`${prefix}_firstName`] =
                    "Enter First Name";
            }

            if (!traveller.lastName?.trim()) {
                newErrors[`${prefix}_lastName`] =
                    "Enter Last Name";
            }

            if (!traveller.dob) {
                newErrors[`${prefix}_dob`] =
                    "Select Date of Birth";
            }

            if (!traveller.age) {
                newErrors[`${prefix}_age`] =
                    "Enter Age";
            }

            if (tripType === "International" && !traveller.passportNumber?.trim()) {
                newErrors[`${prefix}_passportNumber`] =
                    "Enter Passport Number";
            }

            if (!traveller.address?.trim()) {
                newErrors[`${prefix}_address`] =
                    "Enter Address";
            }

            if (!traveller.city?.trim()) {
                newErrors[`${prefix}_city`] =
                    "Enter City";
            }

            if (!traveller.district?.trim()) {
                newErrors[`${prefix}_district`] =
                    "Enter District";
            }

            if (!traveller.state?.trim()) {
                newErrors[`${prefix}_state`] =
                    "Enter State";
            }

            if (!traveller.country?.trim()) {
                newErrors[`${prefix}_country`] =
                    "Enter Country";
            }

            if (!traveller.pincode?.trim()) {
                newErrors[`${prefix}_pincode`] =
                    "Enter Pincode";
            }

            if (!traveller.mobileNo?.trim()) {
                newErrors[`${prefix}_mobileNo`] =
                    "Enter Mobile Number";
            }

            if (
                traveller.mobileNo &&
                !/^[0-9]{10}$/.test(traveller.mobileNo)
            ) {
                newErrors[`${prefix}_mobileNo`] =
                    "Enter Valid Mobile Number";
            }

            if (!traveller.email?.trim()) {
                newErrors[`${prefix}_email`] =
                    "Enter Email";
            }

            if (
                traveller.email &&
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                    traveller.email
                )
            ) {
                newErrors[`${prefix}_email`] =
                    "Enter Valid Email";
            }

            if (!traveller.nominee?.trim()) {
                newErrors[`${prefix}_nominee`] =
                    "Enter Nominee Name";
            }

            if (!traveller.relationship?.trim()) {
                newErrors[`${prefix}_relationship`] =
                    "Enter Relationship";
            }

            if (!traveller.medicalCondition) {
                newErrors[`${prefix}_medicalCondition`] =
                    "Select Medical Condition";
            }
        });

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            return;
        }

        // Save all travellers
        setTravellerData(travellers);

        console.log("Traveller Data:", travellers);

        nextStep();
    };

    const riderData =
        selectedPlan?.riders
            ?.filter((rider) => selectedRiders.includes(rider.id))
            ?.map((rider) => {
                const premiums = Array.isArray(selectedPlan?.agePremiums)
                    ? selectedPlan.agePremiums
                    : [];

                const ageWisePremiums = premiums.map((item) => ({
                    age: item.age,
                    premium: Number(item.premium || 0),
                    riderPremium:
                        Number(rider?.premiumPercent || 0) > 0
                            ? (Number(item.premium || 0) * Number(rider.premiumPercent)) / 100
                            : Number(rider?.riderValue || 0),
                }));

                const totalRiderPremium = ageWisePremiums.reduce(
                    (sum, item) => sum + Number(item.riderPremium || 0),
                    0
                );

                return {
                    riderId: rider.id,
                    riderName: rider.name,
                    premiumPercent: rider.premiumPercent,
                    riderValue: rider.riderValue,
                    premiumAmount: totalRiderPremium,
                    riderRateType: rider.rateType,
                    ageWisePremiums,
                };
            }) || [];

    // const allAgeWisePremiums = riderData.flatMap(
    //     (rider) => rider.ageWisePremiums
    // );

    //setAgeWisePremiums(allAgeWisePremiums);

    const planDetails =
        bookingData?.selectedInsurance?.plan
            ? JSON.parse(
                bookingData.selectedInsurance
                    .plan
            )
            : {};

    const handlePaymentSubmit = async () => {
        setPaymentError("");
        setTermsError("");
        setSuccess("");

        // Payment Method Validation
        if (!paymentMethod) {
            setPaymentError("Please select a payment method before continuing.");
            return;
        }

        // Agency Credit Balance Validation
        if (paymentMethod === "AgencyWallet") {
            const balance = parseFloat(agencyDetails?.corporateDetails?.cashBalance || 0);
            if (balance <= 0) {
                setPaymentError("Insufficient agency balance for payment.");
                return;
            }
        }

        if (paymentMethod === "AgencyCreditLimit") {
            const balance = parseFloat(agencyDetails?.corporateDetails?.cashBalance || 0) + parseFloat(agencyDetails?.corporateDetails?.creditLimit || 0);
            if (balance <= 0) {
                setPaymentError("Insufficient agency Credit Limit for payment.");
                return;
            }
        }

        // Terms Checkbox Validation
        if (!acceptedTerms) {
            setTermsError("Please accept the Terms & Conditions before continuing.");
            return;
        }

        try {
            debugger;
            setLoading(true);
            const response = await AddPassengerDetails({
                clientCode: clientCode,
                key: key,
                referenceNo: referenceNo,
                userName,
                contactDetails,
                travellerData,
                riders: riderData,
            });
            console.log(response);
            if (response?.status === "success") {
                setSuccess("Pax saved successfully!");

                const emulateCorporateCode = localStorage.getItem("selectedCorporateCode");
                const userId = emulateCorporateCode || corporateId;
                //call here Api To collect Payment 
                const response = await CollectPayment({
                    transactionID: referenceNo,
                    referenceNo: referenceNo,
                    corporateCode: userId,
                    userId: userName,
                    service: "Insurance",
                    sessionId: key,
                    transactionType: "",
                    remarks: "",
                    totalAmount: grandTotal,//totalFare,
                    creditLimit: true,
                    status: "",
                    paymentMode: {
                        paymentModeType: "",//organizationsDetails.companyType,
                        cardType: "",
                        productType: "",
                        pgProvider: paymentMethod
                    },
                    //paymentMode: paymentMethod,
                    ipAddress: "",
                });
                console.log("webPaymentLink", response.formHtml);
                if (response?.success === true && response?.message === "Payment form generated.") {
                    window.open(response.formHtml, "_self");
                    //window.open(response.formHtml, "_blank");
                }

                else if (response?.success === true) {
                    setSuccess("Payment successful!!");
                    const response = await CreatePolicy({
                        clientCode: clientCode,
                        userID: userName,
                        key: key,
                        referenceNo: referenceNo,
                    });
                    //if (response?.message === "Success") {
                    navigate(`/insurance/Thankyou?ReferenceNo=${referenceNo}&Key=${key}&ClientCode=${clientCode}`);
                    //}

                } else {
                    setPaymentError(response?.message || "Payment fail. Try again.");
                }
            } else {
                setPaymentError(response?.data?.message || "Something went wrong. Try again.");
            }
        } catch (error) {
            console.error("Payment API Error:", error);
            setPaymentError("Something went wrong. Please try again later.");
        } finally {
            setLoading(false);
        }
    };
    const handleTravellerChange = (
        index,
        field,
        value
    ) => {
        const updated = [...travellers];

        updated[index][field] = value;

        setTravellers(updated);
    };


    const [contact, setContact] = useState({
        email: "",
        countryCode: "91",
        phone: "",
    });

    useEffect(() => {
        const fetchBooking = async () => {
            try {
                const response =
                    await RetrieveSelectedPlan(referenceNo);

                setBookingData(response);

                const corporateCode =
                    localStorage.getItem(
                        "selectedCorporateCode"
                    );

                const userId =
                    localStorage.getItem(
                        "selectedUserId"
                    );

                const agentDetailsResponse =
                    await RetrieveCorporateDetails(
                        userName,
                        corporateCode,
                        userId
                    );

                setAgencyDetails(
                    agentDetailsResponse.data
                );

                const corporateDetails =
                    agentDetailsResponse?.data
                        ?.corporateDetails;

                const phone =
                    corporateDetails?.phoneNumber ||
                    "";

                let countryCode = "91";
                let mobile = "";

                if (phone.includes(" ")) {
                    [countryCode, mobile] =
                        phone.split(" ");
                } else {
                    mobile = phone;
                }

                setContact({
                    email:
                        corporateDetails?.email || "",
                    countryCode,
                    phone: mobile,
                });
            } catch (error) {
                console.error(error);
            }
        };

        if (
            referenceNo &&
            key &&
            clientCode
        ) {
            fetchBooking();
        }
    }, [referenceNo, key, clientCode]);

    const SubmitApprovalRequest = async () => {
        //HandleFormSubmit()
        setTermsError("");
        setSuccess("");
        try {
            setLoading(true);
            const response = await AddPassengerDetails({
                clientCode: clientCode,
                key: key,
                referenceNo: referenceNo,
                userName,
                contactDetails,
                travellerData,
                riders: riderData,
            });
            console.log(response);
            if (response?.status === "success") {

                const approvalResponse = await ApprovalRequest({
                    referenceNo: referenceNo,
                    key: key,
                    userId: userName,
                    product: "Insurance",
                    level1ApproverType: policyData?.firstLevelApproval,
                    level2ApproverType: policyData?.secondLevelApproval,
                    level1CustomApprover: policyData?.firstLevelCustomApproval,
                    level2CustomApprover: policyData?.secondLevelCustomApproval,
                });
                if (approvalResponse?.success === true) {
                    alert(approvalResponse?.message);
                    navigate(`/Insurance`);
                } else {
                    setPaymentError(approvalResponse?.message || "Approval Request fail. Try again.");
                }
            } else {
                alert(response?.error?.desc || "Add Passenger Details failed");
            }

        } catch (error) {
            //console.error(error);
            //alert("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const today = new Date();
    const minDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());

    // const DatePickerInput = ({
    //     value,
    //     onChange,
    //     minDate,
    //     maxDate,
    //     placeholder,
    //     className,
    //     id,
    //     readOnly = true
    // }) => {
    //     const inputRef = useRef(null);

    //     useEffect(() => {
    //         const $input = $(inputRef.current);

    //         // Initialize datepicker
    //         $input.datepicker({
    //             dateFormat: 'mm/dd/yy',
    //             changeMonth: true,
    //             changeYear: true,
    //             yearRange: 'c-100:c+0',
    //             maxDate: maxDate || new Date(),
    //             minDate: minDate || new Date(new Date().getFullYear() - 100, 0, 1),
    //             showButtonPanel: true,
    //             onSelect: function (dateText) {
    //                 // Parse date in local timezone
    //                 const parts = dateText.split('/');
    //                 const month = parseInt(parts[0]) - 1;
    //                 const day = parseInt(parts[1]);
    //                 const year = parseInt(parts[2]);

    //                 // Format as YYYY-MM-DD
    //                 const formattedDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    //                 onChange(formattedDate);
    //             }
    //         });

    //         // Set initial value if provided
    //         if (value) {
    //             const parts = value.split('-');
    //             if (parts.length === 3) {
    //                 const date = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    //                 $input.datepicker('setDate', date);
    //             }
    //         }

    //         // Cleanup
    //         return () => {
    //             $input.datepicker('destroy');
    //         };
    //     }, [minDate, maxDate]);

    //     // Update when value changes externally
    //     useEffect(() => {
    //         if (inputRef.current && value) {
    //             const parts = value.split('-');
    //             if (parts.length === 3) {
    //                 const date = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    //                 $(inputRef.current).datepicker('setDate', date);
    //             }
    //         }
    //     }, [value]);

    //     return (
    //         <input
    //             ref={inputRef}
    //             type="text"
    //             id={id}
    //             className={className || "form-control"}
    //             placeholder={placeholder || "Select Date"}
    //             readOnly={readOnly}
    //         />
    //     );
    // };


    const DatePickerInput = ({
        value,
        onChange,
        minDate,
        maxDate,
        placeholder,
        className,
        id,
        readOnly = true,
        expectedAge,
        onAgeError
    }) => {
        const inputRef = useRef(null);

        useEffect(() => {
            const $input = $(inputRef.current);

            let calculatedMinDate = minDate || new Date(new Date().getFullYear() - 100, 0, 1);
            let calculatedMaxDate = maxDate || new Date();

            if (expectedAge) {
                const today = new Date();
                const currentYear = today.getFullYear();

                // For age 30, we need to show only the years that can give age 29, 30, or 31
                // Example: In 2026, age 29-31 can be from people born in 1994, 1995, 1996, or 1997
                const targetYear = currentYear - parseInt(expectedAge);
                const targetYearPrevious = currentYear - parseInt(expectedAge) - 1;
                const targetYearNext = currentYear - parseInt(expectedAge) + 1;

                // Show years: targetYearPrevious, targetYear, and targetYearNext
                calculatedMinDate = new Date(targetYearPrevious, 0, 1);
                calculatedMaxDate = new Date(targetYearNext, 11, 31);
            }

            $input.datepicker({
                dateFormat: 'mm/dd/yy',
                changeMonth: true,
                changeYear: true,
                // Show years: targetYearPrevious, targetYear, and targetYearNext
                yearRange: expectedAge
                    ? `${new Date().getFullYear() - parseInt(expectedAge) - 1}:${new Date().getFullYear() - parseInt(expectedAge) + 1}`
                    : 'c-100:c+0',
                maxDate: calculatedMaxDate,
                minDate: calculatedMinDate,
                showButtonPanel: true,
                beforeShowDay: function (date) {
                    if (expectedAge) {
                        const today = new Date();

                        // Calculate age accurately
                        let age = today.getFullYear() - date.getFullYear();
                        const monthDiff = today.getMonth() - date.getMonth();
                        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
                            age--;
                        }

                        // Allow dates that give age between 29 and 31 (expectedAge - 1 to expectedAge + 1)
                        const minAge = parseInt(expectedAge) - 1;
                        const maxAge = parseInt(expectedAge) + 1;
                        if (age >= minAge && age <= maxAge) {
                            return [true, 'valid-date', ''];
                        }
                        return [false, 'disabled-date', `Age must be ${expectedAge - 1} to ${expectedAge + 1} years`];
                    }
                    return [true, '', ''];
                },
                onSelect: function (dateText) {
                    const parts = dateText.split('/');
                    const month = parseInt(parts[0]) - 1;
                    const day = parseInt(parts[1]);
                    const year = parseInt(parts[2]);

                    const today = new Date();

                    // Calculate age
                    let age = today.getFullYear() - year;
                    const monthDiff = today.getMonth() - month;
                    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < day)) {
                        age--;
                    }
                    if (age < 0) age = 0;

                    const formattedDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

                    // Validate age range (expectedAge - 1 to expectedAge + 1)
                    if (expectedAge) {
                        const minAge = parseInt(expectedAge) - 1;
                        const maxAge = parseInt(expectedAge) + 1;
                        if (age < minAge || age > maxAge) {
                            if (onAgeError) {
                                onAgeError(`Age must be ${expectedAge - 1} to ${expectedAge + 1} years`);
                            }
                            $input.val('');
                            onChange('', age);
                            return;
                        }
                    }

                    if (onAgeError) {
                        onAgeError('');
                    }

                    onChange(formattedDate, age);
                }
            });

            if (value) {
                const parts = value.split('-');
                if (parts.length === 3) {
                    const date = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
                    $input.datepicker('setDate', date);
                }
            }

            return () => {
                $input.datepicker('destroy');
            };
        }, [minDate, maxDate, expectedAge]);

        useEffect(() => {
            if (inputRef.current && value) {
                const parts = value.split('-');
                if (parts.length === 3) {
                    const date = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
                    $(inputRef.current).datepicker('setDate', date);
                }
            }
        }, [value]);

        return (
            <input
                ref={inputRef}
                type="text"
                id={id}
                className={className || "form-control"}
                placeholder={placeholder || "Select Date"}
                readOnly={readOnly}
            />
        );
    };

    let ApprovalRequestButton = null;
    if ((roles === "Corporate Traveller") && (policyData && policyData.isApprovalRequired)) {
        ApprovalRequestButton = (
            <button className="btn btn-primary" onClick={SubmitApprovalRequest}>
                Request For Approval
            </button>
        );
    }
    else {
        ApprovalRequestButton = (
            <button
                className="btn btn-primary mt-5 mb-5 mx-5"
                onClick={nextStep}
            >
                Save & Next
            </button>
        );
    }

    return (
        <>
            <Header />
            {loading && (
                <p className="text-center load">
                    <span className="loader"></span>
                </p>
            )}
            <section className="wrapers results">
                <div className="container-fluid">
                    <div className="row">

                        {/* Left Side */}
                        <div className="col-md-9">
                            <div className="box_shadow px-8">

                                {/* Stepper */}
                                <div className="steps mb-4 d-flex justify-content-start align-items-center">

                                    <span
                                        className={`Payment ${step >= 1 ? "active" : ""}`}
                                    >
                                        Choose Add-ons
                                    </span>

                                    <span
                                        className={`Payment ${step >= 2 ? "active" : ""}`}
                                    >
                                        Traveller Details
                                    </span>

                                    <span
                                        className={`Payment ${step >= 3 ? "active" : ""}`}
                                    >
                                        Review Details
                                    </span>

                                    <span
                                        className={`Payment ${step >= 4 ? "active" : ""}`}
                                    >
                                        Pay & Book
                                    </span>

                                </div>

                                {/* Step 1 */}
                                {step === 1 && (
                                    <>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h6>Policy Details</h6>
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            {/* <th>Logo</th> */}
                                                            <th>Plan</th>
                                                            <th>Insurer Name</th>
                                                            <th>Premium</th>
                                                            <th>Insured</th>
                                                            <th>Coverage</th>
                                                            <th>Terms And Conditions</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr>
                                                            {/* <td>
                                                                <img
                                                                    src={
                                                                        bookingData?.selectedInsurance
                                                                            ?.insurerLogoPath
                                                                            ? `${process.env.REACT_APP_InsuranceAPI_BASE_URL}/${bookingData.selectedInsurance.insurerLogoPath}`
                                                                            : "/default-logo.png"
                                                                    }
                                                                    alt="Logo"
                                                                    className="logo_bank"
                                                                />
                                                            </td> */}

                                                            <th className="text-success">
                                                                {selectedPlan?.displayName ||
                                                                    selectedPlan?.planName ||
                                                                    "-"}
                                                            </th>

                                                            <td>
                                                                {bookingData?.selectedInsurance
                                                                    ?.insuranceName || "-"}
                                                            </td>

                                                            <td>
                                                                <i className="fa fa-inr"></i>
                                                                {bookingData?.selectedInsurance
                                                                    ?.totalPremium || 0}
                                                            </td>

                                                            <td>
                                                                {(() => {
                                                                    const value = selectedPlan?.sumInsured || "";
                                                                    const currency = value.startsWith("USD") ? "USD" : "INR";
                                                                    const amount = Number(
                                                                        value.replace("INR", "").replace("USD", "").trim()
                                                                    );

                                                                    return `${currency} ${amount.toLocaleString("en-IN")}`;
                                                                })()}
                                                            </td>
                                                            <td>
                                                                <p className="selcted" data-bs-toggle="modal" data-bs-target="#CoverageModal">Selected Coverage</p>
                                                            </td>
                                                            <td>
                                                                <a
                                                                    href={`https://dolphin.asego.in/api/ext/b2b/v1/download?filePath=${selectedPlan?.termsAndConditions}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="selcted"
                                                                >
                                                                    Terms & Conditions
                                                                </a>

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <h6>Travel Details</h6>
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Travel Start Date</th>
                                                            <th>Travel End Date</th>
                                                            <th>Duration</th>
                                                            <th>Age</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                {bookingData?.selectedInsurance
                                                                    ?.startDate}
                                                            </td>

                                                            <td>
                                                                {bookingData?.selectedInsurance
                                                                    ?.endDate}
                                                            </td>

                                                            <td>
                                                                {bookingData?.selectedInsurance
                                                                    ?.duration?.join(", ") ||
                                                                    bookingData?.selectedInsurance
                                                                        ?.duration}
                                                                {" "}Days
                                                            </td>
                                                            <td>
                                                                {bookingData?.selectedInsurance
                                                                    ?.age?.join(", ") ||
                                                                    bookingData?.selectedInsurance
                                                                        ?.age}
                                                                {" "}years
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>


                                            </div>
                                        </div>

                                        {selectedPlan?.riders && selectedPlan?.riders.length > 0 && (
                                            <>
                                                <h6>Add-Ons</h6>
                                                <div className="main_i">
                                                    {selectedPlan?.riders?.slice(0, 10)?.map((rider, index) => (
                                                        <div className="row Repet_i" key={index}>
                                                            <div className="col-md-8 col-lg-8">
                                                                <div className="text_adon">
                                                                    <h4>{rider?.name}</h4>

                                                                    <ul className="features list-disc">
                                                                        {rider?.riderCoverages?.map(
                                                                            (coverage, coverageIndex) => (
                                                                                <li key={coverageIndex}>
                                                                                    <div>
                                                                                        {coverage?.name}
                                                                                        {coverage?.amount && (
                                                                                            <strong>
                                                                                                {coverage.amount}
                                                                                            </strong>
                                                                                        )}
                                                                                    </div>

                                                                                    <div>
                                                                                        {coverage?.deductibles && (
                                                                                            <>

                                                                                                Deductible: <strong>{coverage.deductibles}</strong>

                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4 col-lg-4">
                                                                <div className="iamount_adon">
                                                                    <div className="price_i">
                                                                        {rider?.premiumPercent && (
                                                                            <>
                                                                                <strong>
                                                                                    {rider.premiumPercent}%{" "}
                                                                                    <small>of premium</small>
                                                                                </strong>

                                                                                <p className="amnt_pr">
                                                                                    Amount :{" "}
                                                                                    <i className="fa fa-inr"></i>
                                                                                    {/* {(
                                                                                (Number(selectedPlan?.premium || 0) *
                                                                                    Number(
                                                                                        rider.premiumPercent
                                                                                    )) /
                                                                                100
                                                                            ).toFixed(2)} */}
                                                                                    {
                                                                                        (
                                                                                            (selectedPlan?.agePremiums || []).reduce(
                                                                                                (sum, item) =>
                                                                                                    sum +
                                                                                                    (
                                                                                                        Number(rider?.premiumPercent || 0) > 0
                                                                                                            ? (
                                                                                                                Number(item.premium || 0) *
                                                                                                                Number(rider.premiumPercent)
                                                                                                            ) / 100
                                                                                                            : Number(rider?.riderValue || 0)
                                                                                                    ),
                                                                                                0
                                                                                            )
                                                                                        ).toFixed(2)
                                                                                    }
                                                                                </p>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    {/* <div className="click_selct">
                                                                        <button
                                                                            className={`btn-nav-link btn-sm ${
                                                                            selectedRiders.includes(rider?.id) ? "selected-btn" : ""
                                                                            }`}
                                                                            onClick={() => AddAmountExtra(rider)}
                                                                        >
                                                                            {selectedRiders.includes(rider?.id) ? "Selected" : "Select"}
                                                                        </button>
                                                                        </div> */}
                                                                    <div className="click_selct">
                                                                        <button
                                                                            className="btn-nav-link btn-sm"
                                                                            onClick={() =>
                                                                                AddAmountExtra(rider)
                                                                            }
                                                                        >
                                                                            {selectedRiders.includes(
                                                                                rider?.id
                                                                            )
                                                                                ? "Selected"
                                                                                : "Select"}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        )}

                                        <div className="mt-10 d-flex justify-content-between">
                                            <button
                                                className="btn btn-primary"
                                                onClick={prevStep}
                                                disabled={step === 1}
                                            >
                                                Previous
                                            </button>

                                            <button
                                                className="btn btn-primary"
                                                onClick={nextStep}
                                            >
                                                Next
                                            </button>

                                        </div>
                                    </>
                                )}

                                {/* Step 2 */}
                                {step === 2 && (
                                    <div>
                                        <div className="Repeting">
                                            <h6 className="mb-5">Contact Details</h6>
                                            <div className="row">
                                                <div className="col-md-5">
                                                    <div className="form-group">
                                                        <label className="required">
                                                            Email Address
                                                        </label>

                                                        <input
                                                            className="form-control form-control-solid"
                                                            placeholder="Email"
                                                            type="email"
                                                            value={contact.email}
                                                            onChange={(e) =>
                                                                setContact({
                                                                    ...contact,
                                                                    email: e.target.value,
                                                                })
                                                            }
                                                        />

                                                        {errors.email && (
                                                            <p className="errors">
                                                                {errors.email}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-md-5">
                                                    <div className="form-group">
                                                        <label className="required">
                                                            Contact Number
                                                        </label>

                                                        <div className="d-flex">
                                                            <div className="selct">
                                                                <select
                                                                    className="form-select form-select-solid"
                                                                    value={contact.countryCode}
                                                                    onChange={(e) =>
                                                                        setContact({
                                                                            ...contact,
                                                                            countryCode:
                                                                                e.target.value,
                                                                        })
                                                                    }
                                                                >
                                                                    <option value="91">
                                                                        India (+91)
                                                                    </option>
                                                                    <option value="93">
                                                                        Afghanistan (+93)
                                                                    </option>
                                                                    <option value="355">
                                                                        Albania (+355)
                                                                    </option>
                                                                    <option value="213">
                                                                        Algeria (+213)
                                                                    </option>
                                                                </select>
                                                            </div>

                                                            <div className="inpt">
                                                                <input
                                                                    className="form-control form-control-solid"
                                                                    placeholder="Phone"
                                                                    type="text"
                                                                    value={contact.phone}
                                                                    onChange={(e) =>
                                                                        setContact({
                                                                            ...contact,
                                                                            phone: e.target.value,
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </div>

                                                        {errors.phone && (
                                                            <p className="errors">
                                                                {errors.phone}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <p className="text-danger">
                                                        Your booking details will be sent to
                                                        this email address and mobile
                                                        number.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        {travellers.map((traveller, index) => (
                                            <div className="Repeting" key={index}>
                                                <div className="row m-0">
                                                    <h6 className="mb-5">Traveller {index + 1}</h6>

                                                    <div className="col-md-2 col-lg-2">
                                                        <div className="form_group">
                                                            <label className="required">Title</label>

                                                            <select
                                                                className="form-control form-select"
                                                                value={traveller.title}
                                                                onChange={(e) =>
                                                                    handleTravellerChange(
                                                                        index,
                                                                        "title",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            >
                                                                <option value="">-Select-</option>
                                                                <option value="Mr">Mr.</option>
                                                                <option value="Mrs">Mrs.</option>
                                                                <option value="Miss">Miss.</option>
                                                            </select>
                                                            {errors[`traveller_${index}_title`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_title`]}
                                                                </p>
                                                            )}

                                                        </div>
                                                    </div>

                                                    <div className="col-md-2 col-lg-2">
                                                        <div className="form_group">
                                                            <label className="">Age(yrs)</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={traveller.age || bookingData?.selectedInsurance?.age?.[index]}
                                                                placeholder="Age"
                                                                readOnly
                                                            />
                                                            {errors[`traveller_${index}_age`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_age`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">First Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={traveller.firstName}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const filteredValue = value.replace(/[^A-Za-z]/g, '');
                                                                    handleTravellerChange(index, "firstName", filteredValue);
                                                                }}
                                                                placeholder="First Name" />
                                                            {errors[`traveller_${index}_firstName`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_firstName`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">Last Name</label>
                                                            <input type="text" className="form-control"
                                                                value={traveller.lastName || ""}

                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const filteredValue = value.replace(/[^A-Za-z]/g, '');
                                                                    handleTravellerChange(index, "lastName", filteredValue);
                                                                }}
                                                                placeholder="Last Name" />
                                                            {errors[`traveller_${index}_lastName`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_lastName`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">Email</label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                value={traveller.email || ""}
                                                                placeholder="Email"
                                                                onChange={(e) => {
                                                                    const value = e.target.value.trimStart();
                                                                    handleTravellerChange(
                                                                        index,
                                                                        "email",
                                                                        value
                                                                    );
                                                                }}
                                                            />

                                                            {errors[`traveller_${index}_email`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_email`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">Mobile No</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={traveller.mobileNo || ""}
                                                                placeholder="Mobile No"
                                                                maxLength={10}
                                                                onChange={(e) => {
                                                                    const value = e.target.value
                                                                        .replace(/\D/g, "") // Allow only numbers
                                                                        .slice(0, 10);      // Limit to 10 digits

                                                                    handleTravellerChange(
                                                                        index,
                                                                        "mobileNo",
                                                                        value
                                                                    );
                                                                }}
                                                            />

                                                            {errors[`traveller_${index}_mobileNo`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_mobileNo`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">Date of Birth</label>
                                                            <DatePickerInput
                                                                value={traveller.dob}
                                                                onChange={(dateString, calculatedAge) => {
                                                                    handleTravellerChange(index, "dob", dateString);
                                                                    if (calculatedAge !== undefined) {
                                                                        handleTravellerChange(index, "age", calculatedAge.toString());
                                                                    }
                                                                }}
                                                                minDate={minDate}
                                                                maxDate={new Date()}
                                                                placeholder="Select DOB"
                                                                className="form-control"
                                                                expectedAge={bookingData?.selectedInsurance?.age?.[index]}
                                                                onAgeError={(errorMsg) => {
                                                                    setErrors(prev => ({
                                                                        ...prev,
                                                                        [`traveller_${index}_ageError`]: errorMsg
                                                                    }));
                                                                }}
                                                            />

                                                            {errors[`traveller_${index}_dob`] && (
                                                                <p className="errors">{errors[`traveller_${index}_dob`]}</p>
                                                            )}
                                                            {errors[`traveller_${index}_ageError`] && (
                                                                <p className="errors" style={{ color: '#dc3545' }}>
                                                                    {errors[`traveller_${index}_ageError`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className={tripType === "International" ? "required" : ""} >Passport Number</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={traveller.passportNumber || ""}
                                                                onChange={(e) =>
                                                                    handleTravellerChange(
                                                                        index,
                                                                        "passportNumber",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                placeholder="Passport Number"
                                                            />
                                                            {errors[`traveller_${index}_passportNumber`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_passportNumber`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">City</label>
                                                            <input type="text" className="form-control"
                                                                value={traveller.city || ""}
                                                                onChange={(e) =>
                                                                    handleTravellerChange(
                                                                        index,
                                                                        "city",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                placeholder="City" />
                                                            {errors[`traveller_${index}_city`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_city`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">District</label>
                                                            <input type="text" className="form-control"
                                                                value={traveller.district || ""}
                                                                onChange={(e) =>
                                                                    handleTravellerChange(
                                                                        index,
                                                                        "district",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                placeholder="District" />
                                                            {errors[`traveller_${index}_district`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_district`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">State</label>
                                                            <input type="text" className="form-control"
                                                                value={traveller.state || ""}
                                                                onChange={(e) =>
                                                                    handleTravellerChange(
                                                                        index,
                                                                        "state",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                placeholder="State" />
                                                            {errors[`traveller_${index}_state`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_state`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">Country</label>
                                                            <select
                                                                className="form-control form-select"
                                                                value={traveller.country || ""}
                                                                onChange={(e) =>
                                                                    handleTravellerChange(
                                                                        index,
                                                                        "country",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            >
                                                                <option value="">Select Country</option>
                                                                <option value="AU">Australia</option>
                                                                <option value="AT">Austria</option>
                                                                <option value="BE">Belgium</option>
                                                                <option value="CA">Canada</option>
                                                                <option value="DK">Denmark</option>
                                                                <option value="CZ">Czech Republic</option>
                                                                <option value="DE">Germany</option>
                                                                <option value="FR">France</option>
                                                                <option value="MX">Mexico</option>
                                                                <option value="NZ">New Zealand</option>
                                                                <option value="NO">Norway</option>
                                                                <option value="ES">Spain</option>
                                                                <option value="CH">Switzerland</option>
                                                                <option value="UK">United Kingdom</option>
                                                                <option value="US">United States of America</option>
                                                                <option value="AF">Afghanistan</option>
                                                                <option value="AL">Albania</option>
                                                                <option value="DZ">Algeria</option>
                                                                <option value="AS">American Samoa</option>
                                                                <option value="AD">Andorra</option>
                                                                <option value="AO">Angola</option>
                                                                <option value="AI">Anguilla</option>
                                                                <option value="AQ">Antarctica</option>
                                                                <option value="AG">Antigua And Barbuda</option>
                                                                <option value="AR">Argentina</option>
                                                                <option value="AM">Armenia</option>
                                                                <option value="AW">Aruba</option>
                                                                <option value="AU">Australia</option>
                                                                <option value="AT">Austria</option>
                                                                <option value="AZ">Azerbaijan</option>
                                                                <option value="BS">Bahamas, The</option>
                                                                <option value="BH">Bahrain</option>
                                                                <option value="BD">Bangladesh</option>
                                                                <option value="BB">Barbados</option>
                                                                <option value="BY">Belarus</option>
                                                                <option value="BE">Belgium</option>
                                                                <option value="BZ">Belize</option>
                                                                <option value="BJ">Benin</option>
                                                                <option value="BM">Bermuda</option>
                                                                <option value="BT">Bhutan</option>
                                                                <option value="BO">Bolivia</option>
                                                                <option value="BA">Bosnia and Herzegovina</option>
                                                                <option value="BW">Botswana</option>
                                                                <option value="BV">Bouvet Island</option>
                                                                <option value="BR">Brazil</option>
                                                                <option value="IO">British Indian Ocean Territory</option>
                                                                <option value="BN">Brunei</option>
                                                                <option value="BG">Bulgaria</option>
                                                                <option value="BF">Burkina Faso</option>
                                                                <option value="BI">Burundi</option>
                                                                <option value="KH">Cambodia</option>
                                                                <option value="CM">Cameroon</option>
                                                                <option value="CA">Canada</option>
                                                                <option value="CV">Cape Verde</option>
                                                                <option value="KY">Cayman Islands</option>
                                                                <option value="CF">Central African Republic</option>
                                                                <option value="TD">Chad</option>
                                                                <option value="CL">Chile</option>
                                                                <option value="CN">China</option>
                                                                <option value="HK">China (Hong Kong S.A.R.)</option>
                                                                <option value="MO">China (Macau S.A.R.)</option>
                                                                <option value="CX">Christmas</option>
                                                                <option value="CC">Cocos (Keeling) Islands</option>
                                                                <option value="CO">Colombia</option>
                                                                <option value="KM">Comoros</option>
                                                                <option value="CG">Congo</option>
                                                                <option value="CD">Congo, Democractic Republic of</option>
                                                                <option value="CK">Cook Islands</option>
                                                                <option value="CR">Costa Rica</option>
                                                                <option value="CI">Cote D'Ivoire (Ivory Coast)</option>
                                                                <option value="HR">Croatia (Hrvatska)</option>
                                                                <option value="CU">Cuba</option>
                                                                <option value="CY">Cyprus</option>
                                                                <option value="CZ">Czech Republic</option>
                                                                <option value="DK">Denmark</option>
                                                                <option value="DJ">Djibouti</option>
                                                                <option value="DM">Dominica</option>
                                                                <option value="DO">Dominican Republic</option>
                                                                <option value="TP">East Timor</option>
                                                                <option value="EC">Ecuador</option>
                                                                <option value="EG">Egypt</option>
                                                                <option value="SV">El Salvador</option>
                                                                <option value="GQ">Equatorial Guinea</option>
                                                                <option value="ER">Eritrea</option>
                                                                <option value="EE">Estonia</option>
                                                                <option value="ET">Ethiopia</option>
                                                                <option value="FK">Falkland Islands (Islas Malvin)</option>
                                                                <option value="FO">Faroe Islands</option>
                                                                <option value="FJ">Fiji Islands</option>
                                                                <option value="FI">Finland</option>
                                                                <option value="FR">France</option>
                                                                <option value="GF">French Guiana</option>
                                                                <option value="PF">French Polynesia</option>
                                                                <option value="TF">French Southern Territories</option>
                                                                <option value="GA">Gabon</option>
                                                                <option value="GM">Gambia, The</option>
                                                                <option value="GE">Georgia</option>
                                                                <option value="DE">Germany</option>
                                                                <option value="GH">Ghana</option>
                                                                <option value="GI">Gibraltar</option>
                                                                <option value="GR">Greece</option>
                                                                <option value="GL">Greenland</option>
                                                                <option value="GD">Grenada</option>
                                                                <option value="GP">Guadeloupe</option>
                                                                <option value="GU">Guam</option>
                                                                <option value="GT">Guatemala</option>
                                                                <option value="GN">Guinea</option>
                                                                <option value="GW">Guinea-Bissau</option>
                                                                <option value="GY">Guyana</option>
                                                                <option value="HT">Haiti</option>
                                                                <option value="HM">Heard and McDonald Islands</option>
                                                                <option value="HN">Honduras</option>
                                                                <option value="HU">Hungary</option>
                                                                <option value="IS">Iceland</option>
                                                                <option value="IN">India</option>
                                                                <option value="ID">Indonesia</option>
                                                                <option value="IR">Iran</option>
                                                                <option value="IQ">Iraq</option>
                                                                <option value="IE">Ireland</option>
                                                                <option value="IL">Israel</option>
                                                                <option value="IT">Italy</option>
                                                                <option value="JM">Jamaica</option>
                                                                <option value="JP">Japan</option>
                                                                <option value="JO">Jordan</option>
                                                                <option value="KZ">Kazakhstan</option>
                                                                <option value="KE">Kenya</option>
                                                                <option value="KI">Kiribati</option>
                                                                <option value="KR">Korea</option>
                                                                <option value="KP">Korea, North</option>
                                                                <option value="KW">Kuwait</option>
                                                                <option value="KG">Kyrgyzstan</option>
                                                                <option value="LA">Laos PDR</option>
                                                                <option value="LV">Latvia</option>
                                                                <option value="LB">Lebanon</option>
                                                                <option value="LS">Lesotho</option>
                                                                <option value="LR">Liberia</option>
                                                                <option value="LY">Libya</option>
                                                                <option value="LI">Liechtenstein</option>
                                                                <option value="LT">Lithuania</option>
                                                                <option value="LU">Luxembourg</option>
                                                                <option value="MK">Macedonia</option>
                                                                <option value="MG">Madagascar</option>
                                                                <option value="MW">Malawi</option>
                                                                <option value="MY">Malaysia</option>
                                                                <option value="MV">Maldives</option>
                                                                <option value="ML">Mali</option>
                                                                <option value="MT">Malta</option>
                                                                <option value="MH">Marshall Islands</option>
                                                                <option value="MQ">Martinique</option>
                                                                <option value="MR">Mauritania</option>
                                                                <option value="MU">Mauritius</option>
                                                                <option value="YT">Mayotte</option>
                                                                <option value="MX">Mexico</option>
                                                                <option value="FM">Micronesia</option>
                                                                <option value="MD">Moldova</option>
                                                                <option value="MC">Monaco</option>
                                                                <option value="MN">Mongolia</option>
                                                                <option value="ME">Montenegro</option>
                                                                <option value="MS">Montserrat</option>
                                                                <option value="MA">Morocco</option>
                                                                <option value="MZ">Mozambique</option>
                                                                <option value="MM">Myanmar</option>
                                                                <option value="NA">Namibia</option>
                                                                <option value="NR">Nauru</option>
                                                                <option value="NP">Nepal</option>
                                                                <option value="AN">Netherlands Antilles</option>
                                                                <option value="NC">New Caledonia</option>
                                                                {/* <option value="NZ">New Zealand</option> */}
                                                                <option value="NI">Nicaragua</option>
                                                                <option value="NE">Niger</option>
                                                                <option value="NG">Nigeria</option>
                                                                <option value="NU">Niue</option>
                                                                <option value="NF">Norfolk Island</option>
                                                                <option value="MP">Northern Mariana Islands</option>
                                                                <option value="NO">Norway</option>
                                                                <option value="OM">Oman</option>
                                                                <option value="PK">Pakistan</option>
                                                                <option value="PW">Palau</option>
                                                                <option value="PA">Panama</option>
                                                                <option value="PG">Papua new Guinea</option>
                                                                <option value="PY">Paraguay</option>
                                                                <option value="PE">Peru</option>
                                                                <option value="PH">Philippines</option>
                                                                <option value="PN">Pitcairn Island</option>
                                                                <option value="PL">Poland</option>
                                                                <option value="PT">Portugal</option>
                                                                <option value="PR">Puerto Rico</option>
                                                                <option value="QA">Qatar</option>
                                                                <option value="RE">Reunion</option>
                                                                <option value="RO">Romania</option>
                                                                <option value="RU">Russia</option>
                                                                <option value="RW">Rwanda</option>
                                                                <option value="SH">Saint Helena</option>
                                                                <option value="KN">Saint Kitts And Nevis</option>
                                                                <option value="LC">Saint Lucia</option>
                                                                <option value="PM">Saint Pierre and Miquelon</option>
                                                                <option value="VC">Saint Vincent And The Grenadin</option>
                                                                <option value="WS">Samoa</option>
                                                                <option value="SM">San Marino</option>
                                                                <option value="ST">Sao Tome and Principe</option>
                                                                <option value="SA">Saudi Arabia</option>
                                                                <option value="SN">Senegal</option>
                                                                <option value="RS">Serbia</option>
                                                                <option value="SC">Seychelles</option>
                                                                <option value="SL">Sierra Leone</option>
                                                                <option value="SG">Singapore</option>
                                                                <option value="SK">Slovakia</option>
                                                                <option value="SI">Slovenia</option>
                                                                <option value="SB">Solomon Islands</option>
                                                                <option value="SO">Somalia</option>
                                                                <option value="ZA">South Africa</option>
                                                                <option value="GS">South Georgia</option>
                                                                <option value="ES">Spain</option>
                                                                <option value="LK">Sri Lanka</option>
                                                                <option value="SD">Sudan</option>
                                                                <option value="SR">Suriname</option>
                                                                <option value="SJ">Svalbard And Jan Mayen Islands</option>
                                                                <option value="SZ">Swaziland</option>
                                                                <option value="SE">Sweden</option>
                                                                <option value="CH">Switzerland</option>
                                                                <option value="SY">Syria</option>
                                                                <option value="TW">Taiwan</option>
                                                                <option value="TJ">Tajikistan</option>
                                                                <option value="TZ">Tanzania</option>
                                                                <option value="TH">Thailand</option>
                                                                <option value="NL">The Netherlands</option>
                                                                <option value="TG">Togo</option>
                                                                <option value="TK">Tokelau</option>
                                                                <option value="TO">Tonga</option>
                                                                <option value="TT">Trinidad And Tobago</option>
                                                                <option value="TN">Tunisia</option>
                                                                <option value="TR">Turkey</option>
                                                                <option value="TM">Turkmenistan</option>
                                                                <option value="TC">Turks And Caicos Islands</option>
                                                                <option value="TV">Tuvalu</option>
                                                                <option value="UG">Uganda</option>
                                                                <option value="UA">Ukraine</option>
                                                                <option value="AE">United Arab Emirates</option>
                                                                <option value="UK">United Kingdom</option>
                                                                <option value="UM">United States Minor Outlying I</option>
                                                                <option value="US">United States of America</option>
                                                                <option value="UY">Uruguay</option>
                                                                <option value="UZ">Uzbekistan</option>
                                                                <option value="VU">Vanuatu</option>
                                                                <option value="VA">Vatican City State (Holy See)</option>
                                                                <option value="VE">Venezuela</option>
                                                                <option value="VN">Vietnam</option>
                                                                <option value="VG">Virgin Islands (British)</option>
                                                                <option value="VI">Virgin Islands (US)</option>
                                                                <option value="WF">Wallis And Futuna Islands</option>
                                                                <option value="EH">Western Sahara</option>
                                                                <option value="YE">Yemen</option>
                                                                <option value="YU">Yugoslavia</option>
                                                                <option value="ZM">Zambia</option>
                                                                <option value="ZW">Zimbabwe</option>

                                                            </select>

                                                            {errors[`traveller_${index}_country`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_country`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">Pincode</label>
                                                            <input type="text" className="form-control"
                                                                value={traveller.pincode || ""}
                                                                onChange={(e) =>
                                                                    handleTravellerChange(
                                                                        index,
                                                                        "pincode",
                                                                        e.target.value.replace(/\D/g, "").slice(0, 6)
                                                                    )
                                                                }
                                                                placeholder="Pincode"
                                                                maxLength={6}
                                                                inputMode="numeric"
                                                            />
                                                            {errors[`traveller_${index}_pincode`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_pincode`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>


                                                    <div className="col-md-12 col-lg-12">
                                                        <div className="form_group">
                                                            <label className="required">Address</label>
                                                            <input type="text" className="form-control"
                                                                value={traveller.address || ""}
                                                                onChange={(e) =>
                                                                    handleTravellerChange(
                                                                        index,
                                                                        "address",
                                                                        e.target.value
                                                                    )
                                                                }
                                                                placeholder="Address" />
                                                            {errors[`traveller_${index}_address`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_address`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <h5 className="Nominee_a">Emergency Contact Details</h5>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label>Person Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={traveller.emergencyContactPerson || ""}
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/[^A-Za-z\s\-']/g, "");
                                                                    handleTravellerChange(index, "emergencyContactPerson", value);
                                                                }}
                                                                placeholder="Person Name"
                                                            />
                                                            {errors[`traveller_${index}_emergencyContactPerson`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_emergencyContactPerson`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label>Person Contact Number</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={traveller.emergencyContactNumber || ""}
                                                                maxLength={10}
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/\D/g, "");
                                                                    handleTravellerChange(index, "emergencyContactNumber", value);
                                                                }}
                                                                placeholder="Person Contact Number"
                                                            />
                                                            {errors[`traveller_${index}_emergencyContactNumber`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_emergencyContactNumber`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label>Person Email Address</label>
                                                            <input
                                                                type="email"
                                                                className="form-control"
                                                                value={traveller.emergencyEmailId || ""}
                                                                onChange={(e) => {
                                                                    handleTravellerChange(index, "emergencyEmailId", e.target.value);
                                                                }}
                                                                placeholder="Person Email Address"
                                                            />
                                                            {errors[`traveller_${index}_emergencyEmailId`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_emergencyEmailId`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <h5 className="Nominee_a">Nominee Details</h5>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">Nominee</label>
                                                            <input type="text" className="form-control"
                                                                value={traveller.nominee || ""}
                                                                onChange={(e) => {
                                                                    // Allow letters, spaces, hyphens, and apostrophes
                                                                    const value = e.target.value;
                                                                    const filteredValue = value.replace(/[^A-Za-z\s\-']/g, '');
                                                                    handleTravellerChange(index, "nominee", filteredValue);
                                                                }}
                                                                placeholder="Nominee Name" />
                                                            {errors[`traveller_${index}_nominee`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_nominee`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-lg-4">
                                                        <div className="form_group">
                                                            <label className="required">Relationship</label>
                                                            <select
                                                                className="form-control form-select"
                                                                value={traveller.relationship || ""}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const filteredValue = value.replace(/[^A-Za-z\s\-']/g, '');
                                                                    handleTravellerChange(index, "relationship", filteredValue);
                                                                }}
                                                            >
                                                                <option value="">Select Relationship</option>
                                                                <option value="aunty">Aunty</option>
                                                                <option value="brother">Brother</option>
                                                                <option value="brother-in-law">Brother-in-law</option>
                                                                <option value="daughter">Daughter</option>
                                                                <option value="daughter in law">Daughter In Law</option>
                                                                <option value="father">Father</option>
                                                                <option value="father in law">Father In Law</option>
                                                                <option value="friend">Friend</option>
                                                                <option value="grand mother">Grand Mother</option>
                                                                <option value="grand son">Grand Son</option>
                                                                <option value="granddaughter">Grand Daughter</option>
                                                                <option value="grandfather">Grand Father</option>
                                                                <option value="husband">Husband</option>
                                                                <option value="legal heir">Legal Heir</option>
                                                                <option value="mother">Mother</option>
                                                                <option value="mother in law">Mother In Law</option>
                                                                <option value="nephew">Nephew</option>
                                                                <option value="self">Self</option>
                                                                <option value="sister">Sister</option>
                                                                <option value="sister in law">Sister In Law</option>
                                                                <option value="son">Son</option>
                                                                <option value="son in law">Son In Law</option>
                                                                <option value="uncle">Uncle</option>
                                                                <option value="wife">Wife</option>
                                                                <option value="cousin">Cousin</option>
                                                                <option value="niece">Niece</option>
                                                                <option value="others">Others</option>
                                                            </select>

                                                            {errors[`traveller_${index}_relationship`] && (
                                                                <p className="errors">
                                                                    {errors[`traveller_${index}_relationship`]}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div class="d-flex mt-5">
                                                            <div className="Does">Does the traveller have a pre-existing medical condition?</div>


                                                            <div class="travel_mode insurc">
                                                                <div class="form-check form-check-custom form-check-solid">
                                                                    <input
                                                                        className="form-check-input"
                                                                        id="yes"
                                                                        type="radio"
                                                                        value="Yes"
                                                                        name={`med_${index}`}
                                                                        checked={
                                                                            traveller.medicalCondition === "Yes"
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleTravellerChange(
                                                                                index,
                                                                                "medicalCondition",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                    <label class="form-check-label" for="yes">Yes</label>
                                                                </div>
                                                            </div>
                                                            <div class="travel_mode insurc">
                                                                <div class="form-check form-check-custom form-check-solid">
                                                                    <input
                                                                        className="form-check-input"
                                                                        id="no"
                                                                        type="radio"
                                                                        value="No"
                                                                        name={`med_${index}`}
                                                                        checked={
                                                                            traveller.medicalCondition === "No"
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleTravellerChange(
                                                                                index,
                                                                                "medicalCondition",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                    <label class="form-check-label" for="no">No</label>
                                                                </div></div>

                                                        </div>
                                                        {errors[`traveller_${index}_medicalCondition`] && (
                                                            <p className="errors">
                                                                {errors[`traveller_${index}_medicalCondition`]}
                                                            </p>
                                                        )}

                                                    </div>
                                                    <div className="col-md-12">
                                                        <div class="d-flex mt-5">
                                                            <div className="Does">Does the traveller have a past illness medical condition?</div>
                                                            <div class="travel_mode insurc">
                                                                <div class="form-check form-check-custom form-check-solid">
                                                                    <input
                                                                        className="form-check-input"
                                                                        id="yes"
                                                                        type="radio"
                                                                        value="Yes"
                                                                        name={`pastillness_${index}`}
                                                                        checked={
                                                                            traveller.pastillness === "Yes"
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleTravellerChange(
                                                                                index,
                                                                                "pastillness",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                    <label class="form-check-label" for="yes">Yes</label>
                                                                </div>
                                                            </div>
                                                            <div class="travel_mode insurc">
                                                                <div class="form-check form-check-custom form-check-solid">
                                                                    <input
                                                                        className="form-check-input"
                                                                        id="no"
                                                                        type="radio"
                                                                        value="No"
                                                                        name={`pastillness_${index}`}
                                                                        checked={
                                                                            traveller.pastillness === "No"
                                                                        }
                                                                        onChange={(e) =>
                                                                            handleTravellerChange(
                                                                                index,
                                                                                "pastillness",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                    <label class="form-check-label" for="no">No</label>
                                                                </div></div>

                                                        </div>
                                                        {errors[`traveller_${index}_pastillness`] && (
                                                            <p className="errors">
                                                                {errors[`traveller_${index}_pastillness`]}
                                                            </p>
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        {contactDetails?.gstNumber && (
                                            <div className="Repeting">
                                                <h6 className="mb-5">GST Details</h6>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="required">
                                                                GST Number
                                                            </label>
                                                            <input
                                                                className="form-control form-control-solid"
                                                                maxLength={15}
                                                                type="text"
                                                                name="gstNumber"
                                                                value={contactDetails?.gstNumber || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="required">
                                                                Name
                                                            </label>
                                                            <input
                                                                className="form-control form-control-solid"
                                                                type="text"
                                                                name="gstName"
                                                                value={contactDetails?.gstName || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="required">
                                                                Email
                                                            </label>
                                                            <input
                                                                className="form-control form-control-solid"
                                                                type="email"
                                                                name="emailOngst"
                                                                value={contactDetails?.emailOngst || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label className="required">
                                                                Phone
                                                            </label>
                                                            <input
                                                                className="form-control form-control-solid"
                                                                maxLength={10}
                                                                type="text"
                                                                name="phoneOnGst"
                                                                value={contactDetails?.phoneOnGst || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="required">
                                                                Address
                                                            </label>
                                                            <input
                                                                className="form-control form-control-solid"
                                                                type="text"
                                                                name="addressOnGst"
                                                                value={contactDetails?.addressOnGst || ""}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="mt-10 d-flex justify-content-between">
                                            <button
                                                className="btn btn-primary"
                                                onClick={prevStep}
                                            >
                                                Previous
                                            </button>
                                            <button
                                                className="btn btn-primary"
                                                onClick={HandleFormSubmit}
                                            >
                                                Save & Next
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Step 3 */}
                                {step === 3 && (
                                    <div>
                                        <div className="col-md-12 col-lg-12">
                                            <div className="table_revie">
                                                <h6>Review Details</h6>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="list_vie">
                                                            Start Date :
                                                            <span>
                                                                {bookingData?.selectedInsurance?.startDate ||
                                                                    "N/A"}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="list_vie">
                                                            End Date :
                                                            <span>
                                                                {bookingData?.selectedInsurance?.endDate ||
                                                                    "N/A"}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <div className="list_vie">
                                                            Duration :
                                                            <span>
                                                                {bookingData?.selectedInsurance?.duration?.[0] ||
                                                                    0}{" "}
                                                                Days
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Product Details */}
                                                    <div className="col-md-12 mt-10">
                                                        <h6>Product Details</h6>

                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>Insurer</th>
                                                                    <th>Sum Insured</th>
                                                                    <th>Plan Name</th>
                                                                    <th>Premium</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        {bookingData?.selectedInsurance?.insuranceName || "N/A"}
                                                                    </td>

                                                                    <td>
                                                                        {planDetails?.sumInsured ||
                                                                            planDetails?.selectedInsurance?.sumInsured ||
                                                                            "N/A"}
                                                                    </td>

                                                                    <th className="text-success">

                                                                        {selectedPlan?.displayName ||
                                                                            selectedPlan?.planName ||
                                                                            "-"}
                                                                    </th>

                                                                    <td>
                                                                        <i className="fa fa-inr"></i>{" "}
                                                                        {bookingData?.selectedInsurance?.totalPremium ||
                                                                            planDetails?.totalPremium ||
                                                                            planDetails?.premium ||
                                                                            "0"}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="col-md-12 mt-10">
                                                        <h6>Riders Details</h6>

                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th>Rider Name</th>
                                                                    <th>Premium %</th>
                                                                    <th>Premium Amount</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {riderData?.length > 0 ? (
                                                                    riderData.map(
                                                                        (rider, index) => (
                                                                            <tr key={index}>
                                                                                <td>{rider?.riderName || "-"}</td>
                                                                                <td>{rider?.premiumPercent || 0}</td>
                                                                                <td>{rider?.premiumAmount.toFixed(2)}</td>
                                                                            </tr>
                                                                        )
                                                                    )
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="3" className="text-center">
                                                                            No Riders Selected
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {/* Traveller Details */}
                                                    {
                                                        travellerData?.map((traveller, index) => (
                                                            <div className="col-md-12" key={index}>

                                                                <h6 className="mb-5 mt-5">Traveller {index + 1}</h6>
                                                                <div className="row border-bottom">
                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Passport :
                                                                            <span>{traveller?.passportNumber || "N/A"}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Full Name :
                                                                            <span>
                                                                                {traveller?.title || "N/A"} {`${traveller?.firstName || ""} ${traveller?.lastName || ""}`}
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Date of Birth :
                                                                            <span>{traveller?.dob || "N/A"}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Age :
                                                                            <span>{traveller?.age || "N/A"}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Mobile No :
                                                                            <span>{traveller?.mobileNo || "N/A"}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Email :
                                                                            <span>{traveller?.email || "N/A"}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Nominee :
                                                                            <span>{traveller?.nominee || "N/A"}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Relationship :
                                                                            <span>{traveller?.relationship || "N/A"}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Pincode :
                                                                            <span>{traveller?.pincode || "N/A"}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            District :
                                                                            <span>{traveller?.district || "N/A"}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            City :
                                                                            <span>{traveller?.city || "N/A"}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            State :
                                                                            <span>{traveller?.state || "N/A"}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Country :
                                                                            <span>{traveller?.country || "N/A"}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-12">
                                                                        <div className="list_vie">
                                                                            Address :
                                                                            <span>{traveller?.address || "N/A"}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Pre-existing medical :
                                                                            <span>
                                                                                {traveller?.medicalCondition === "Yes"
                                                                                    ? "Yes"
                                                                                    : traveller?.medicalCondition === "No"
                                                                                        ? "No"
                                                                                        : "N/A"}
                                                                            </span>
                                                                            {/* <span>{traveller?.medicalCondition || "N/A"}</span> */}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Pre-existing medical :
                                                                            <span>
                                                                                {traveller?.pastillness === "Yes"
                                                                                    ? "Yes"
                                                                                    : traveller?.pastillness === "No"
                                                                                        ? "No"
                                                                                        : "N/A"}
                                                                            </span>
                                                                            {/* <span>{traveller?.medicalCondition || "N/A"}</span> */}
                                                                        </div>
                                                                    </div>
                                                                    <h5 className="mt-3">Emergency Contact Person Details</h5>
                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Person Name :
                                                                            <span>{traveller?.emergencyContactPerson || "N/A"}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Person Phone :
                                                                            <span>{traveller?.emergencyContactNumber || "N/A"}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="list_vie">
                                                                            Person Email ID :
                                                                            <span>{traveller?.emergencyEmailId || "N/A"}</span>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-10 d-flex justify-content-between">
                                            <button
                                                className="btn btn-primary mt-5 mb-5 mx-5"
                                                onClick={prevStep}
                                            >
                                                Previous
                                            </button>

                                            {/* <button
                                                className="btn btn-primary"
                                                onClick={nextStep}
                                            // onClick={savePaxDetails}
                                            >
                                                Save & Confirm
                                            </button> */}
                                            {ApprovalRequestButton}
                                        </div>
                                    </div>

                                )}
                                {step === 4 && (
                                    <>
                                        <div className="col-md-12 col-lg-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <h4 className="sub_heading">Payment</h4>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="paymnt">
                                                        <div className="paymnt_lft">
                                                            <ul className="nav nav-tabs paynt" role="tablist">
                                                                <li className="nav-item">
                                                                    <a className="nav-link active" data-bs-toggle="tab" href="#AgencyCredit">Company Billing</a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">Credit Card</a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">Debit Card</a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">Net Banking</a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">UPI</a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="paymnt_Rgt">
                                                            <div className="tab-content">
                                                                <div id="AgencyCredit" className="container tab-pane active">
                                                                    <div className="balnce">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="paymentMethod"
                                                                            id="agencyCreditRadio"
                                                                            value="AgencyCreditLimit"
                                                                            checked={paymentMethod === "AgencyCreditLimit"}
                                                                            onChange={(e) => {
                                                                                setPaymentMethod(e.target.value)
                                                                                setPaymentError("");
                                                                            }}
                                                                        />
                                                                        <i className="fa fa-inr"></i>{(parseFloat(agencyDetails?.corporateDetails?.creditLimit ?? 0) + parseFloat(agencyDetails?.corporateDetails?.dueAmount ?? 0)).toFixed(2)}</div>
                                                                    {/* <i className="fa fa-inr"></i>{agencyDea.cashBalance}</div> */}
                                                                </div>
                                                                <div id="CreditCard" className="container tab-pane fade">
                                                                    <div className="balnce">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="HdfcBank"
                                                                            id="HdfcBankRadio"
                                                                            value="HdfcBank"
                                                                            checked={paymentMethod === "HdfcBank"}
                                                                            onChange={(e) => {
                                                                                setPaymentMethod(e.target.value)
                                                                                setPaymentError("");
                                                                            }
                                                                            }
                                                                        />
                                                                        <img src="/assets/images/hdfc-logo.png" alt="payment" /> </div>
                                                                </div>
                                                                <div id="DebitCard" className="container tab-pane fade">
                                                                    <div className="balnce">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="paymentMethod"
                                                                            id="debitCardRadio"
                                                                            value="DebitCard"
                                                                            checked={paymentMethod === "DebitCard"}
                                                                            onChange={(e) => {
                                                                                setPaymentMethod(e.target.value)
                                                                                setPaymentError("");
                                                                            }}
                                                                        />
                                                                        <i className="fa fa-inr"></i>36565</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {paymentError && (
                                                        <div className="alert alert-danger fw-bold mt-3 py-2">
                                                            {paymentError}
                                                        </div>
                                                    )}
                                                    {/* {error && <p className="text-danger mt-3">{error}</p>}
                          {success && <p className="text-success mt-3">{success}</p>} */}
                                                </div>

                                                <div className="col-md-12 mt-5 mb-5">
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            id="termsCheckbox"
                                                            name="Status"
                                                            type="checkbox"
                                                            checked={acceptedTerms}
                                                            onChange={(e) => {
                                                                setAcceptedTerms(e.target.checked);
                                                                if (e.target.checked) setTermsError("");
                                                            }}
                                                        />
                                                        {/* <input className="form-check-input" id="Active" name="Status" type="checkbox" value="1" /> */}
                                                        <label className="form-check-label Active" for="Active"> By clicking this button, I understand &amp; accept with the	Rules &amp; Restrictions of this fare,the Privacy Policy
                                                            <span data-bs-toggle="modal" data-bs-target="#term-cond" className="weak">Terms &amp; Conditions</span></label>
                                                    </div>
                                                    {termsError && (
                                                        <div className="alert alert-danger fw-bold mt-3 py-2">
                                                            {termsError}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-10 d-flex justify-content-between">
                                            <button
                                                className="btn btn-primary"
                                                onClick={prevStep}
                                            >
                                                Previous
                                            </button>

                                            <button
                                                className="btn btn-primary"
                                                onClick={handlePaymentSubmit}
                                            >
                                                Pay & Book
                                            </button>

                                        </div>
                                    </>
                                )}
                                {/* Buttons */}


                            </div>
                        </div>

                        {/* Right Side */}
                        <div className="col-md-3">
                            <div className="box_shadow p-4">
                                <div className="fare_sum">
                                    <h5>Premium Summary</h5>

                                    <div className="flex">
                                        <span>Premium</span>
                                        <span>
                                            <i className="fa fa-inr"></i>
                                            {premium.toFixed(2)}
                                        </span>
                                    </div>

                                    <div className="flex">
                                        <span>Add-ons</span>
                                        <span>
                                            <i className="fa fa-inr"></i>
                                            {addonTotal.toFixed(2)}
                                        </span>
                                    </div>

                                    {/* <div className="flex">
                                        <span>GST</span>
                                        <span>
                                            <i className="fa fa-inr"></i>
                                            {gst.toFixed(2)}
                                        </span>
                                    </div> */}
                                </div>

                                <div className="d-flexes">
                                    <div className="totals">
                                        GRAND TOTAL
                                    </div>

                                    <div className="tolt_price">
                                        <span>
                                            <i className="fa fa-inr"></i>
                                            {grandTotal.toFixed(2)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="modal fade" id="CoverageModal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Coverage Details</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead
                                        className="table-dark-1"
                                    // style={{ backgroundColor: "#110942", color: "#ffffff" }}
                                    >
                                        <tr>
                                            <th>#</th>
                                            <th>Coverage Name</th>
                                            <th>Maximum Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedPlan?.coverages?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.name}</td>
                                                <td>
                                                    <strong>{item.maxAmount}</strong>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* model pop start */}
            <div className="modal fade" id="term-cond" >
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Terms And Conditions</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body termsPrivacy">

                            <div className='row'>
                                <div className='col-md-12 box_shadow'>
                                    <p>These Terms of Service (the “User Agreement“) constitute a legally binding agreement made between Berry Journeys Private Limited (“Berry Journeys”), a travel services company incorporated and existing in India in accordance with the Companies Act, 1956 and user, whether personally or on behalf of an entity (“User/User”) and concerning user access to and use of the Berry Journeys.com website as well as mobile application related, linked, or otherwise connected thereto (collectively, the “Site”). </p>
                                    <p>Berry Journeys is a travel services website owned and operated by Berry Journeys Private Limited, hereinafter referred to as (“Berry Journeys”/ “we”/ “us” or “our”).
                                    </p>
                                    <p>User agree that by accessing the site, he has read, understood, and agree to be bound by all of these Terms of Service. If user do not agree with all of these Terms of Service, then the user must discontinue use immediately.</p>
                                    <p>Supplemental terms and conditions or documents that may be posted on the site from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to this User Agreement at any time and for any reason.
                                    </p>
                                    <p>We will alert user about any changes by updating the “Last updated” date of these Terms of Use, and user waive any right to receive specific notice of each such change.
                                    </p>
                                    <p>It is user responsibility to periodically review these Terms of Use to stay informed of updates. User will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Terms of Use by user continued use of the Site after the date such revised Terms of Use are posted.</p>
                                    <p>The information provided on the Site is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country.
                                    </p>
                                    <p>Accordingly, those persons who choose to access the site from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable. </p>

                                    <h2>ELIGIBILITY</h2>
                                    <p>The site is intended for users who are at least 18 years old. Persons under the age of 18 are not permitted to register for the site. If user is a minor, User must have user parent or guardian read and agree to these Terms of Use prior to user using the site. </p>



                                    <h2>INTELLECTUAL PROPERTY RIGHTS</h2>
                                    <p>Unless otherwise indicated, the site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (the “Marks”) are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of the United States, foreign jurisdictions, and international conventions. </p>
                                    <p>The Content and the Marks are provided on the Site “AS IS” for user information and personal use only. Except as expressly provided in these Terms of Use, no part of the site and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.
                                    </p>
                                    <p>Provided that User are eligible to use the Site, User are granted a limited license to access and use the Site and to download or print a copy of any portion of the Content to which user have properly gained access solely for user personal, non-commercial use. We reserve all rights not expressly granted to user in and to the site, the Content and the Marks.
                                    </p>

                                    <h2>USER REPRESENTATIONS</h2>
                                    <p>By using the site, user represent and warrant that: </p>
                                    <ul>
                                        <li>All registration information user submit will be true, accurate, current, and complete
                                        </li>
                                        <li>User will maintain the accuracy of such information and promptly update such registration information as necessary</li>
                                        <li>User have the legal capacity and user agree to comply with this User Agreement;</li>
                                        <li>User are not under the age of 18;</li>
                                        <li>not a minor in the jurisdiction in which user reside, or if a minor, user have received parental permission to use the Site;</li>
                                        <li>user will not access the Site through automated or non-human means, whether through a bot, script, or otherwise;</li>
                                        <li>User will not use the Site for any illegal or unauthorized purpose;</li>
                                        <li>User use of the Site will not violate any applicable law or regulation.</li>
                                        <li>If user provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or terminate user account and refuse any and all current or future use of the Site (or any portion thereof).</li>

                                    </ul>

                                    <h2>USER REGISTRATION</h2>
                                    <p>User may be required to register with the Site. User agree to keep user password confidential and will be responsible for all use of user account and password. We reserve the right to remove, reclaim, or change a username user select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable or we have reason to believe that password might have compromised to any external threat.</p>

                                    <h2>FRAUDULENT ACTIVITIES, FAKE CALLS & SCAMS</h2>
                                    <p>Berry Journey’s representatives will never ask for any personal information like credit/debit card number, CVV, OTP, card expiry date, user IDs, passwords, etc. Also, user will never be asked to install any third-party applications that grant access to user mobile or computer screen.</p>
                                    <p>Beware of anyone who is claiming to be associated with Berry Journey’s. Acting on any such requests may make user a victim of fraud, potentially leading to the loss of valuable information or money.</p>
                                    <h2>PROHIBITED ACTIVITIES</h2>
                                    <p>User may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us. </p>
                                    <p>As a User of the Site, user agree not to:
                                    </p>
                                    <ul>
                                        <li>systematically retrieve data or other content from the Site to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.</li>
                                        <li>make any unauthorized use of the Site, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.</li>
                                        <li>use a buying agent or purchasing agent to make purchases on the Site.</li>
                                        <li>use the Site to advertise or offer to sell goods and services.</li>
                                        <li>circumvent, disable, or otherwise interfere with security-related features of the Site, including features that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Site and/or the Content contained therein.</li>
                                        <li>engage in unauthorized framing of or linking to the Site.</li>
                                        <li>trick, defraud, or mislead us and other Users, especially in any attempt to learn sensitive account information such as User passwords;</li>
                                        <li>make improper use of our support services or submit false reports of abuse or misconduct.</li>
                                        <li>engage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.</li>
                                        <li>interfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.</li>
                                        <li>attempt to impersonate another User or person or use the username of another User.</li>

                                    </ul>
                                    <h2>sell or otherwise transfer user profile.</h2>
                                    <ul>
                                        <li>use any information obtained from the Site in order to harass, abuse, or harm another person.</li>
                                        <li>use the Site as part of any effort to compete with us or otherwise use the Site and/or the Content for any revenue-generating endeavor or commercial enterprise.</li>
                                        <li>decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Site.</li>
                                        <li>attempt to bypass any measures of the Site designed to prevent or restrict access to the Site, or any portion of the Site.</li>
                                        <li>harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Site to user.</li>
                                        <li>delete the copyright or other proprietary rights notice from any Content.</li>
                                        <li>copy or adapt the Site’s software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.</li>

                                    </ul>
                                    <p>upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the Site or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the Site.</p>
                                    <p>upload or transmit (or attempt to upload or transmit) any material that acts as a passive or active information collection or transmission mechanism, including without limitation, clear graphics interchange formats (“gifs”), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as “spyware” or “passive collection mechanisms” or “pcms”).</p>
                                    <p>except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the Site, or using or launching any unauthorized script or other software.</p>
                                    <p>disparage, tarnish, or otherwise harm, in our opinion, us and/or the Site.</p>
                                    <p>use the Site in a manner inconsistent with any applicable laws or regulations.</p>
                                    <h1>MOBILE APPLICATION LICENSE</h1>
                                    <h2>Use License</h2>
                                    <p>If user access the Site via a mobile application, then we grant user a revocable, non-exclusive, non-transferable, limited right to install and use the mobile application on wireless electronic devices owned or controlled by user, and to access and use the mobile application on such devices strictly in accordance with the terms and conditions of this mobile application license contained in these Terms of Use. </p>

                                    <h2>User shall not: </h2>
                                    <ol>
                                        <li> decompile, reverse engineer, disassemble, attempt to derive the source code of, or decrypt the application; </li>
                                        <li>make any modification, adaptation, improvement, enhancement, translation, or derivative work from the application; </li>
                                        <li>violate any applicable laws, rules, or regulations in connection with user access or use of the application; </li>
                                        <li>remove, alter, or obscure any proprietary notice (including any notice of copyright or trademark) posted by us or the licensors of the application; </li>
                                        <li>use the application for any revenue generating endeavor, commercial enterprise, or other purpose for which it is not designed or intended; </li>
                                        <li>make the application available over a network or other environment permitting access or use by multiple devices or users at the same time;</li>
                                        <li>use the application for creating a product, service, or software that is, directly or indirectly, competitive with or in any way a substitute for the application; </li>
                                        <li>use the application to send automated queries to any website or to send any unsolicited commercial e-mail; </li>
                                        <li>use any proprietary information or any of our interfaces or our other intellectual property in the design, development, manufacture, licensing, or distribution of any applications, accessories, or devices for use with the application.</li>
                                    </ol>


                                    <h2>Apple and Android Devices</h2>
                                    <p>The following terms apply when user use a mobile application obtained from either the Apple Store or Google Play Store (each an “App Distributor”) to access the Site:
                                    </p>

                                    <ol>
                                        <li>the license granted to user for our mobile application is limited to a non-transferable license to use the application on a device that utilizes the Apple iOS or Android operating systems, as applicable, and in accordance with the usage rules set forth in the applicable App Distributor’s terms of service; </li>
                                        <li> we are responsible for providing any maintenance and support services with respect to the mobile application as specified in the terms and conditions of this mobile application license contained in these Terms of Use or as otherwise required under applicable law, and user acknowledge that each App Distributor has no obligation whatsoever to furnish any maintenance and support services with respect to the mobile application; </li>
                                        <li>user acknowledge and agree that the App Distributors are third-party beneficiaries of the terms and conditions in this mobile application license contained in these Terms of Use, and that each App Distributor will have the right (and will be deemed to have accepted the right) to enforce the terms and conditions in this mobile application license contained in these Terms of Use against user as a third-party beneficiary thereof.  </li>

                                    </ol>
                                    <h2>SUBMISSIONS</h2>
                                    <p>User acknowledge and agree that any questions, comments, suggestions, ideas, feedback, or other information regarding the Site (“Submissions”) provided by user to us are non-confidential and shall become our sole property. We shall own exclusive rights, including all intellectual property rights, and shall be entitled to the unrestricted use and dissemination of these Submissions for any lawful purpose, commercial or otherwise, without acknowledgment or compensation to user. </p>
                                    <p>User hereby waive all moral rights to any such Submissions, and user hereby warrant that any such Submissions are original with user or that user have the right to submit such Submissions. User agree there shall be no recourse against us for any alleged or actual infringement or misappropriation of any proprietary right in user Submissions. </p>
                                    <h2>THIRD-PARTY WEBSITES AND CONTENT</h2>
                                    <p>The Site may contain (or user may be sent via the Site) links to other websites (“Third-Party Websites”) as well as articles, photographs, text, graphics, pictures, designs, music, sound, video, information, applications, software, and other content or items belonging to or originating from third parties (“Third-Party Content”). </p>
                                    <p>Such Third-Party Websites and Third-Party Content are not investigated, monitored, or checked for accuracy, appropriateness, or completeness by us, and we are not responsible for any Third-Party Websites accessed through the Site or any Third-Party Content posted on, available through, or installed from the Site, including the content, accuracy, offensiveness, opinions, reliability, privacy practices, or other policies of or contained in the Third-Party Websites or the Third-Party Content. </p>
                                    <p>Inclusion of, linking to, or permitting the use or installation of any Third-Party Websites or any Third-Party Content does not imply approval or endorsement thereof by us. If user decide to leave the Site and access the Third-Party Websites or to use or install any Third-Party Content, user do so at user own risk, and user should be aware these Terms of Use no longer govern.
                                    </p>
                                    <p>User should review the applicable terms and policies, including privacy and data gathering practices, of any website to which user navigate from the Site or relating to any applications user use or install from the Site. Any purchases user make through Third-Party Websites will be through other websites and from other companies, and we take no responsibility whatsoever in relation to such purchases which are exclusively between user and the applicable third party. </p>
                                    <p>User agree and acknowledge that we do not endorse the products or services offered on Third-Party Websites and user shall hold us harmless from any harm caused by user purchase of such products or services. Additionally, user shall hold us harmless from any losses sustained by user or harm caused to user relating to or resulting in any way from any Third-Party Content or any contact with Third-Party Websites. </p>

                                    <h2>SITE MANAGEMENT</h2>
                                    <p>We reserve the right, but not the obligation, to: </p>
                                    <ol>
                                        <li>monitor the Site for violations of these Terms of Use;</li>
                                        <li>take appropriate legal action against anyone who, in our sole discretion, violates the law or these Terms of Use, including without limitation, reporting such User to law enforcement authorities;
                                        </li>
                                        <li> in our sole discretion and without limitation, refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of user Contributions or any portion thereof; </li>
                                        <li> in our sole discretion and without limitation, notice, or liability, to remove from the Site or otherwise disable all files and content that are excessive in size or are in any way burdensome to our systems; </li>
                                        <li>otherwise manage the Site in a manner designed to protect our rights and property and to facilitate the proper functioning of the Site.</li>

                                    </ol>

                                    <h2>PRIVACY POLICY</h2>
                                    <p>We care about data privacy and security. Please review our Privacy Policy here to learn more about how we collect and use information about User via our Site. By using the Site, user agree to be bound by our Privacy Policy, which is incorporated into these Terms of Use. </p>
                                    <p>We do not knowingly accept, request, or solicit information from children or knowingly market to children. If we receive actual knowledge that anyone under the age of 13 has provided personal information to us without the requisite and verifiable parental consent, we will delete that information from the Site as quickly as is reasonably practical.
                                    </p>
                                    <h2>INTELLECTUAL PROPERTY RIGHTS INFRINGEMENTS</h2>
                                    <p>We respect the intellectual property rights of others. If user believe that any material available on or through the Site infringes upon any Intellectual Property Rights (“IPR”) user own or control, please immediately notify us at hello@BerryJourneys.com. A copy of user notification will be sent to the person who posted or stored the material addressed in the notification.
                                    </p>
                                    <p>Please be advised that pursuant to applicable law user may be held liable for damages if user make material misrepresentations in user notification. Thus, if user are not sure that material located on or linked to by the Site infringes user IPR, user should consider first contacting an attorney.
                                    </p>
                                    <h2>FEES AND PAYMENTS</h2>
                                    <p>Over and above booking charges for the products/ services offered on the Site, Berry Journeys may charge certain fees in the nature of convenience fees, service fees, finance fee, payment gateway charges (“Additional Fees”) for making services conveniently available to User online. Berry Journeys further reserves the right to alter any and all fees from time to time without prior notice to the User. Any such Additional Fees will be displayed to the User before confirming the booking or collecting the payment to enable user to make an informed choice.</p>
                                    <p>The User is responsible for payment of all charges, fees, duties, taxes, and assessments resulting out of the use of the Site, as per the applicable laws. In cases where booking amount, taxes, statutory fee, service fees, convenience fee, payment gateway charges etc. are not properly charged or undercharged (“Balance Amount”), owing to any technical error or other reason, Berry Journeys reserves the right to deduct, charge or claim the Balance Amount from the User and the User shall pay such Balance Amount to Berry Journeys. In cases where such Balance Amount is claimed prior to the utilization of the booking, Berry Journeys will be at liberty to cancel such bookings if the amount is not paid before the utilization date.</p>
                                    <p>In the event there is any addition in the prices charged by us as a result of change in applicable law including but not limited to, changes in tax rates or imposition of new taxes, or levies by Government, such increased charge will have to be borne by the User. Berry Journeys may introduce such additional charges without prior notice to the User and could also be retrospective, but will always be as per applicable law.</p>
                                    <p>In the rare event of a booking not getting confirmed for any reason whatsoever, Berry Journeys shall not be liable to offer an alternate booking in lieu of or to compensate the unconfirmed booking. Any succeeding booking will be regarded as a new transaction. The pertinent refund will be processed to the User as per the relevant policies of the third party and BERRY JOURNEYS as the case may be.</p>
                                    <p>No communication will ever be made by us or any of our employees or authorized representatives enquiring about a User’s credit or debit card number, expiry date, CVV, net banking login, passwords, OTP, request for a fund transfer to a personal or an individual bank account, installation of any third-party applications that enable them to view a User’s mobile or computer screen. Acting on any of these requests may make user a victim of fraud, and may potentially lead to loss of user valuable money or information.</p>
                                    <p>Please be advised to not share user personal sensitive information like credit/debit card number, CVV, OTP, card expiry date, user IDs, passwords etc. with any person including the agents, employees or representatives of BERRY JOURNEYS. If any such details are requested by any of our agents, employees or representatives, please inform us at the earliest on the contact details mentioned below. However, BERRY JOURNEYS shall not be liable for any loss that the User incurs for sharing the aforesaid details.</p>
                                    <p>All booking(s) made on the Site are subject to the applicable cancellation policy made visible and communicated to the Users on the Site in writing. The applicable refunds on cancelled bookings will be processed to the relevant User account either by way of BERRY JOURNEYS money or reversed to same banking instrument (credit card, debit card, Bank account, wallet etc.) from which initial payment was made.</p>

                                    <h2>TERM AND TERMINATION</h2>
                                    <p>This User Agreement shall remain in full force and effect while user use the Site. WITHOUT LIMITING ANY OTHER PROVISION OF THIS USER AGREEMENT, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THIS USER AGREEMENT OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE USER USE OR PARTICIPATION IN THE SITE OR DELETE USER ACCOUNT AND ANY CONTENT OR INFORMATION THAT USER POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION. </p>
                                    <p>If we terminate or suspend user account for any reason, user are prohibited from registering and creating a new account under user name, a fake or borrowed name, or the name of any third party, even if user may be acting on behalf of the third party. </p>
                                    <p>In addition to terminating or suspending user account, we reserve the right to take appropriate legal action, including without limitation pursuing civil, criminal, and injunctive redress.</p>
                                    <h2>MODIFICATIONS AND INTERRUPTIONS </h2>
                                    <p>We reserve the right to change, modify, or remove the contents of the Site at any time or for any reason at our sole discretion without notice. However, we have no obligation to update any information on our Site. We also reserve the right to modify or discontinue all or part of the Site without notice at any time. </p>
                                    <p>We will not be liable to user or any third party for any modification, price change, suspension, or discontinuance of the Site. </p>
                                    <p>We cannot guarantee the Site will be available at all times. We may experience hardware, software, or other problems or need to perform maintenance related to the Site, resulting in interruptions, delays, or errors. </p>
                                    <p>We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Site at any time or for any reason without notice. User agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by user inability to access or use the Site during any downtime or discontinuance of the Site. </p>
                                    <p>Nothing in these Terms of Use will be construed to obligate us to maintain and support the Site or to supply any corrections, updates, or releases in connection therewith.</p>

                                    <h2>GOVERNING LAW </h2>
                                    <p>This User Agreement and user use of the Site are governed by and construed in accordance with the laws of India and the Parties shall refer any unresolved disputes to the exclusive jurisdiction of courts in Delhi.  </p>

                                    <h2>CORRECTIONS</h2>
                                    <p>There may be information on the Site that contains typographical errors, inaccuracies, or omissions that may relate to the Site, including descriptions, pricing, availability, and various other information. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information on the Site at any time, without prior notice.</p>

                                    <h2>DISCLAIMER</h2>
                                    <p>THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. USER AGREE THAT USER USE OF THE SITE AND OUR SERVICES WILL BE AT USER SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND USER USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM USER ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN USER AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. </p>
                                    <p>AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, USER SHOULD USE USER BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.</p>

                                    <h2>LIMITATIONS OF LIABILITY</h2>
                                    <p>IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO USER OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, </p>
                                    <p>INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM USER USE OF THE SITE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. </p>
                                    <p>NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO USER FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE TOTAL AMOUNT OF TRANSACTION IN QUESTION.
                                    </p>
                                    <h2>INDEMNIFICATION</h2>
                                    <p>User agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable attorney’s fees and expenses, made by any third party due to or arising out of:</p>
                                    <ol>
                                        <li> user Contributions</li>
                                        <li>use of the Site</li>
                                        <li>breach of these Terms of Use; </li>
                                        <li>any breach of user representations and warranties set forth in these Terms of Use;</li>
                                        <li>user violation of the rights of a third party, including but not limited to intellectual property rights;</li>
                                        <li>any overt harmful act toward any other user of the Site with whom user connected via the Site. </li>
                                    </ol>
                                    <p>Notwithstanding the foregoing, we reserve the right, at user expense, to assume the exclusive defense and control of any matter for which user are required to indemnify us, and user agree to cooperate, at user expense, with our defense of such claims. We will use reasonable efforts to notify user of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it. </p>
                                    <h2>USER DATA</h2>
                                    <p>We will maintain certain data that user transmit to the Site for the purpose of managing the Site, as well as data relating to user use of the Site. Although we perform regular routine backups of data, user are solely responsible for all data that user transmit or that relates to any activity user have undertaken using the Site. </p>
                                    <p>User agree that we shall have no liability to user for any loss or corruption of any such data, and user hereby waive any right of action against us arising from any such loss or corruption of such data.</p>
                                    <h2>ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND BERRYS</h2>
                                    <p>Visiting the Site, sending us emails, and completing online forms constitute electronic communications. User consent to receive electronic communications, and user agree that all agreements, notices, disclosures, and other communications we provide to user electronically, via email and on the Site, satisfy any legal requirement that such communication be in writing. </p>
                                    <p>USER HEREBY AGREE TO THE USE OF ELECTRONIC BERRYS, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE. </p>
                                    <p>User hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original Berry or delivery or retention of non-electronic records, or to payments or the granting of credits by any means other than electronic means. </p>
                                    <p>For ease of Users, we also send booking confirmations, itinerary information, cancellations, payment confirmation/status, refund status, booking failure information or any such other information relevant to the transaction or booking made by the User, via SMS, internet-based messaging applications like WhatsApp, voice call, e-mail or any other alternate communication information furnished by the User at the time of booking.</p>
                                    <p>User hereby consent that any such communication through SMS, WhatsApp, voice call, email or any other mode by us are:</p>
                                    <ul>
                                        <li>as per user request and authorization;</li>
                                        <li>‘transactional’ and not an ‘unsolicited commercial communication’ as per the guidelines of Telecom Regulation Authority of India (TRAI), and</li>
                                        <li>in compliance with appropriate guidelines of TRAI or other relevant authority in India and abroad as applicable.</li>
                                    </ul>
                                    <p>User hereby agree to indemnify us against any losses and damages incurred by us due to any action taken by TRAI or any other authority due to any erroneous complaint filed by the User on us on account of communications sent to User as above or failed communication due to a wrong number or email ID shared by the User for any reason whatsoever.</p>
                                    <h2>MISCELLANEOUS</h2>
                                    <p>This User Agreement and any policies or operating rules posted by us on the Site constitute the entire agreement and understanding between User and Berry Journeys. Our failure to exercise or enforce any right or provision of this User Agreement shall not operate as a waiver of such right or provision. </p>
                                    <p>This User Agreement operates to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control.</p>
                                    <p>If any provision or part of a provision of this User Agreement is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from this User Agreement and does not affect the validity and enforceability of any remaining provisions. </p>
                                    <p>There is no joint venture, partnership, employment or agency relationship created between user and us as a result of this User Agreement or use of the Site. User agree that this User Agreement will not be construed against us by virtue of having drafted them. </p>
                                    <p>User hereby waive any and all defenses user may have based on the electronic form of this User Agreement.</p>

                                    <h2>CONTACT US </h2>
                                    <p>In order to resolve a complaint regarding the Site or to receive further information regarding the use of the Site, please contact us at: </p>
                                    <h6>Berry Journeys Private Limited<br />
                                        2nd Floor, Plot no 3, IFFCO Tower,<br />
                                        Sector 29, Gurugram Haryana India – 122001<br />
                                        Email Address: hello@Berry Journeys.com
                                    </h6>
                                    <h1>TERMS OF SERVICE</h1>
                                    <p>All Services offered on Site shall be governed by the following Terms of Service:</p>

                                    <h1>Bus</h1>
                                    <p>BERRY JOURNEYS as a booking platform
                                    </p>
                                    <p> BERRY JOURNEYS provides a facilitator platform to enable the user to book a Bus ticket. The Bus tickets shown to User on the Site for booking are subject to the terms and conditions of the concerned airline, including but not limited to delay, change, cancellation and refund.</p>
                                    <p>Each respective airline retains the right to reschedule the timings of the Buss, routes, cancellation or change in itineraries without prior intimation to us. As a facilitator, BERRY JOURNEYS has no control or authority over the logistics of the airlines and therefore is not liable for any loss, direct or incidental, that a User may suffer due to change in details or cancellation of a booked Bus. Any grievances, if any, will be handled and decided directly by the concerned airline.</p>
                                    <p>the User shall ensure to carry and have sole responsibility of carrying valid travel documents at the time of the journey including but not limited to identity proof, passport, visa (including transit visa if applicable) to prove the identity, nationality and age of passengers (adult or infant) travelling on a ticket. BERRY JOURNEYS shall have no liability for damages arising out of User inability to carry valid or appropriate documents at the time of travel.</p>
                                    <p> In the event that a User does not board the onward Bus on the day of travel, the entire PNR generated for that booking shall stand cancelled. BERRY JOURNEYS under no circumstances will be liable to compensate the User for missing the Bus. In such an event, the airline cancellation policy will be applicable.</p>
                                    <p> Check-in timings may vary from airline to airline. Users are hereby advised to check with the airline prior for the check-in timings. Usually, check-in commences two (02) hours before departure for domestic Buss, and 3 hours before departure for international Buss. Pricing: Airfares shown on our platform are inclusive of various airline charges, including but not limited to Base Fare, Fuel Surcharge, User Development Fees, Passenger Service Fees, Terminal Equipment Fee, Airport Development fee, etc. as the case may be and Government Taxes. Additionally, we charge convenience/service fee (collectively referred to as “Fee”) for providing the online booking facility varying parameters selected by the User at the time of booking. The User hereby agrees to pay the entire amount including all statutory taxes, surcharges and fees, as applicable at the time of booking the ticket.</p>
                                    <p> Different tickets on the same airline may carry different limitations or include different services and price, as the case may be. The baggage allowance on a given Bus is shown as per the terms of the airline, and is not controlled by us. There may be instances where airline imposes “hand baggage fares” wherein User will be required to pay separately for check-in baggage. The prices for adding check-in baggage to a booking may vary from airline to airline. The User is advised to get in touch with the airlines for detailed costs/charges. Infant Fares: Infant Fares will be applicable subject to the following conditions:</p>
                                    <ul>
                                        <li>The infant must be accompanied by an adult as per the terms of the airline.</li>
                                        <li> The infant must be under 24 months of age throughout the journey i.e. both onward as well as return journey.</li>
                                        <li> If the infant turns 24 months or above at the time of return journey, User will be required to make a separate booking as per applicable child fare. Changes to existing booking: The User shall be liable to pay applicable charges (charged by the respective airline and BERRY JOURNEYS) for any alteration or modification to an existing booking. However, depending on the concerned airline’s policy and fare class, amount of charge may vary.
                                        </li>

                                    </ul>
                                    <p>Cancellations and Refunds: All refunds are subject to airline fare rules and cancellation policy, and shall be made by BERRY JOURNEYS only on the receipt of such refund from the airline. Users are hereby advised to check with the airline in advance and read about their cancellation policy.
                                        THE USER AGREES THAT ANY FEE CHARGED BY BERRY JOURNEYS INCLUDING BERRY JOURNEYS SERVICE FEE AND CONVENIENCE FEE PAID BY THE USER AT THE TIME OF BOOKING IS A NON-REFUNDABLE FEE. ANY REFUND TO THE USER SHALL BE PROCESSED AFTER DEDUCTING EQUIVALENT AMOUNT TOWARDS THE FEE.    </p>
                                    <p>Please intimate us at the earliest where any cancellations are made directly with the airline in order to initiate the process of refund to the User. The processing time for refunds may differ depending on the mode of payment, bank etc. In instances where tickets were only partially utilized, refund shall be made after deducting any discount and/or promo code discount availed at the time of booking.
                                        The refund will be credited to the User bank account/ credit card/debit card/wallet etc. from which the payment was originally made by the User unless the User has chosen for instant refund through any other payment mode, after deducting the applicable BERRY JOURNEYS charges. For instance, if the User used a credit card, the refund will be made to the corresponding credit card. Similarly, if the User had used a debit card for the payment, refund will be made to the same debit card.</p>
                                    <p> BERRY JOURNEYS Fare Recommendations help the Users to identify the best time to book their Bus. BERRY JOURNEYS recommendations are based on our proprietary data model which is derived from analysis of historical prices. However, we do not guarantee the final outcome
                                    </p>
                                    <h1>HOTELS</h1>
                                    <p>Role of BERRY JOURNEYS as a Booking Platform
                                    </p>
                                    <p>For ease of Users to book Hotels online, BERRY JOURNEYS has partnered with various hotel aggregators (“Hotel Aggregators”) by providing a technology platform for booking Hotels and collecting payments directly on BERRY JOURNEYS platform. Our Site allow Users to search across multiple Hotel accommodation providers in a selected area including BERRY JOURNEYS as a booking platform wherever applicable. Based
                                    </p>
                                    <p>Under this arrangement, BERRY JOURNEYS provides a technology platform, facilitating transactions between Hotels and Users by providing them with a choice of Hotel types, check-in and check-out time etc.</p>
                                    <p>However, we do not own or operate any Hotel services of our own. The selection of any specific Hotel is entirely on the choice of User. BERRY JOURNEYS shall not be responsible for the operations of the Hotel and any service related disputes shall be raised directly with the Hotel.
                                    </p>
                                    <p>BERRY JOURNEYS acts as an online facilitator platform for the User to select and book a particular Hotel by collating data relating to Hotel availability from various Booking Partners websites based on User search criteria.</p>
                                    <p> ‘Hotel’ shall mean all categories of accommodations like hotels, home-stays, bed and breakfast stay, etc.</p>
                                    <p><strong>Eligibility</strong> : The primary guest must be at least 18 years of age to be able to book and check-in to the hotel.</p>
                                    <h2></h2>
                                    <h2>Role and Responsibility of the Booking Partners:</h2>
                                    <p>addressing any User complaint or dispute relating to the category of the hotel and/or sufficiency of services, room type selected, amenities and facilities offered at the Hotel. All information displayed on the Site only for reference purposes. BERRY JOURNEYS shall not be liable for any dispute arising from wrong information conveyed.</p>
                                    <h2>Role and Responsibility of the Booking Partners:</h2>
                                    <p>any service-related issues at the Hotel such as change in check-in/ check-out timings, extra bedding, delay in check in due to over-booking, system or technical errors, non-availability of rooms etc.
                                    </p>
                                    <p>All issues relating to payment options i.e. prepaid/postpaid etc will be governed by respective Booking Partner’s and/or Hotel policies.</p>
                                    <h1>BUSES</h1>
                                    <p> For ease of booking online bus tickets, BERRY JOURNEYS has partnered with various bus aggregators (“Aggregators”) to provide a technology platform for purchase of bus tickets through their channel of bus operators.</p>
                                    <p> Aggregators enable travelers to book bus tickets online by providing them with a choice of bus operators, departure time and prices. However, Aggregators do not own or operate any bus services of their own. The selection of any specific bus operator is entirely on the choice of User. Under this arrangement, BERRY JOURNEYS merely provides a technology platform, facilitating transactions between the bus operators and Users. BERRY JOURNEYS shall not be responsible for the operations of the bus operator including, but not limited to the following:
                                    </p>
                                    <h2>Departure or arrival of the buses on time;</h2>
                                    <p>The conduct/behaviour of bus driver or bus operator’s employees, representatives or agents;</p>
                                    <ul>
                                        <li>The physical condition of the bus, seats etc. not being up to the User’s expectation or as per the description furnished by the bus operator on the Platform;</li>
                                        <li>Cancellation of the scheduled trip due to any reasons;</li>
                                        <li>Loss or damage to the User’s luggage;</li>
                                        <li>Change in allocated seat to the User by the bus operator for any reason whatsoever;</li>
                                    </ul>
                                    <p>Bus operator notifying an incorrect boarding point on the booking confirmation voucher, or altering such boarding point later with or without any notification to BERRY JOURNEYS or the User;</p>
                                    <p>Bus operator using a different pick-up vehicle for transportation of the customers from the designated boarding point to the actual place of departure of the bus.</p>
                                    <p>Users are hereby recommended to get in touch with the bus operators in advance for details relating to exact boarding point, charges for additional baggage (if any) or any other information needed for boarding or travel for the scheduled journey.</p>
                                    <ul>
                                        <li> Users are required to carry following documents at the time of boarding the bus:</li>
                                        <li>a print out of the ticket, and</li>
                                        <li>any valid ID like Aadhar card, passport, PAN card or voter ID or any other valid identity proof issued by a government authority.</li>
                                        <li>Users are advised to reach the boarding place no later than thirty (30) minutes before the scheduled departure time. All tickets issued shall be non-transferable.</li>
                                    </ul>
                                    <p>In the event of cancellation of bus ticket on the Site, refund will be made after deduction of applicable Aggregator and BERRY JOURNEYS cancellation charges. Users are advised to read through cancellation terms mentioned on the ticket/Site carefully.
                                        Convenience/Service fee charged by BERRY JOURNEYS at the time of booking the tickets are non-refundable. The refund in such circumstances gets credited to BERRY JOURNEYS money and/or same User bank account/Credit card/Debit card/Wallet etc used for booking tickets unless User has chosen for instant refund through any other payment mode, after deducting the applicable BERRY JOURNEYS charges.</p>

                                    <h1>TRAINS</h1>
                                    <p>BERRY JOURNEYS acts as a facilitator for Users to book and search for desired train tickets on IRCTC platform. All train bookings or reservations made on the Site are subject to the applicable terms and conditions as set out by IRCTC Booking Process</p>
                                    <p>To book train tickets, User will be redirected to IRCTC website/application. Users will need their IRCTC username and password in order to book their tickets on BERRY JOURNEYS website/application.E-tickets are booked and issued through Indian Railways only and are subject to the rules and policies of Indian Railways. Users can book a maximum of 6 seats/ berths in a booking. Seat/ berth allotment is done by Indian Railways based on their allocation logic. BERRY JOURNEYS does not guarantee allotment of preferred seat/ berth. Users with a confirmed e-ticket are permitted to board the train. Their names will appear on the chart. Fully waitlisted e-tickets are automatically cancelled by IRCTC after chart preparation. If fully waitlisted passengers are found travelling, they will be treated as without-ticket and charged as per Railway rules.Booked tickets are non-transferrable and are subject to identification. Users must carry valid ID proofs such as PAN card/ Aadhar Card/ Voter ID etc. at the time of travel or boarding the train for validation.</p>
                                    <p>BERRY JOURNEYS will not be responsible for any schedule change by the Railways. Users are advised to confirm their train timings 24 hours prior to the train departure.</p>
                                    <p> The Railways rules and regulations may change from time to time. Please refer to</p>
                                    <p>http://www.indianrail.gov.in/enquiry/StaticPages/StaticEnquiry.jsp?StaticPage=index.html for the latest rules and regulations. While we endeavor to keep the rules and regulations updated at all times but should not be held responsible for the same.</p>
                                    <p> Please reach out to IRCTC directly for all relevant information/ queries relating to user bookings.</p>

                                    <h2>Modifications</h2>
                                    <p>BERRY JOURNEYS cannot make any modifications to the booked tickets, including but not limited to change in passenger names, change in route, boarding point etc. Any modifications to booked tickets can be made only by IRCTC. We suggest Users to read IRCTC amendment policy here https://www.services.irctc.co.in/beta_htmls/Eticket_new_cancel.html to know more details.
                                    </p>
                                    <p>Payments, Cancellations and RefundsCancellation of booked tickets are subject to IRCTC cancellation policy and charges as per time of cancellation and booking quota (tatkal/ general/ ladies/ premium, etc.) Customers are advised to go through IRCTC cancellation policy prior to cancellation to know about the relevant cancellation charges. User can cancel a train ticket booked via BERRY JOURNEYS, only before chart preparation.</p>
                                    <p> Cancellation charges may vary depending on ticket type and time of ticket cancellation. Cancellations and refunds will be based on Indian Railways refund and TDR filing rules. These rules are subject to change by Indian Railways.</p>
                                    <p> User can find complete details of the Railway cancellation policy and rules here: http://www.indianrail.gov.in/enquiry/StaticPages/StaticEnquiry.jsp?StaticPage=refund_Rules.html&locale=en or http://contents.irctc.co.in/en/eticketCancel.html</p>
                                    <p>Payment Gateway charges/service fee charged by BERRY JOURNEYS at the time of booking the tickets are non-refundable. The refund gets credited to same User bank account/credit card/debit card/wallet, etc. used for booking tickets unless User has chosen for instant refund through any other payment mode, after deducting the applicable BERRY JOURNEYS’s charges.</p>
                                    <h2>USER GENERATED CONTRIBUTIONS</h2>
                                    <p>The Site may invite user to chat, contribute to, or participate in blogs, message boards, online forums, and other functionality, and may provide user with the opportunity to create, submit, post, display, transmit, perform, publish, distribute, or broadcast content and materials to us or on the Site, including but not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material (collectively, “Contributions”). </p>
                                    <p>Contributions may be viewable by other Users of the Site and through third-party websites. As such, any Contributions user transmit may be treated as non-confidential and non-proprietary. When user create or make available any Contributions, user thereby represent and warrant that:</p>
                                    <p>the creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of user contributions do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party.</p>
                                    <p>user are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize us, the site, and other users of the Site to use user Contributions in any manner contemplated by the Site and these Terms of Use.</p>
                                    <p>user have the written consent, release, and/or permission of each and every identifiable individual person in user Contributions to use the name or likeness of each and every such identifiable individual person to enable inclusion and use of user Contributions in any manner contemplated by the Site and these Terms of Use.
                                    </p>
                                    <p>user Contributions are not false, inaccurate, or misleading.</p>
                                    <ul>
                                        <li>user Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain letters, spam, mass mailings, or other forms of solicitation.
                                        </li>
                                        <li>user Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise objectionable (as determined by us).</li>
                                        <li>user Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.
                                        </li>
                                        <li>user Contributions do not violate any applicable law, regulation, or rule.</li>
                                        <li>user Contributions do not violate the privacy or publicity rights of any third party.</li>
                                        <li>user Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual preference, or physical handicap.</li>
                                        <li>user Contributions do not otherwise violate, or link to material that violates, any provision of these Terms of Use, or any applicable law or regulation.</li>
                                        <li>Any use of the Site in violation of the foregoing violates these Terms of Use and may result in, among other things, termination or suspension of user rights to use the Site. </li>
                                    </ul>
                                    <h2>CONTRIBUTION LICENSE</h2>
                                    <p>By posting user Contributions to any part of the Site or making Contributions accessible to the Site by linking user account from the Site to any of user social networking accounts, user automatically grant, and user represent and warrant that user have the right to grant, to us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide right, and license to host, use, copy, reproduce, disclose, sell, resell, publish, broadcast, retitle, archive, store, cache, publicly perform, publicly display, reformat, translate, transmit, excerpt (in whole or in part), and distribute such Contributions (including, without limitation, user image and voice) for any purpose, commercial, advertising, or otherwise, and to prepare derivative works of, or incorporate into other works, such Contributions, and grant and authorize sublicenses of the foregoing. The use and distribution may occur in any media formats and through any media channels. </p>
                                    <p>This license will apply to any form, media, or technology now known or hereafter developed, and includes our use of user name, company name, and franchise name, as applicable, and any of the trademarks, service marks, trade names, logos, and personal and commercial images user provide. User waive all moral rights in user Contributions, and user warrant that moral rights have not otherwise been asserted in user Contributions. </p>
                                    <p>We do not assert any ownership over user Contributions. User retain full ownership of all of user Contributions and any intellectual property rights or other proprietary rights associated with user Contributions. We are not liable for any statements or representations in user Contributions provided by user in any area on the Site.
                                    </p>
                                    <p>User are solely responsible for user Contributions to the Site and user expressly agree to exonerate us from any and all responsibility and to refrain from any legal action against us regarding user Contributions.</p>
                                    <p>We have the right, in our sole and absolute discretion,</p>
                                    <ol>
                                        <li>to edit, redact, or otherwise change any Contributions;</li>
                                        <li> to re-categorize any Contributions to place them in more appropriate locations on the Site; and </li>
                                        <li>to pre-screen or delete any Contributions at any time and for any reason, without notice. We have no obligation to monitor user Contributions. </li>

                                    </ol>

                                    <h2>GUIDELINES FOR REVIEWS</h2>
                                    <p>We may provide user areas on the Site to leave reviews or ratings. When posting a review, user must comply with the following criteria:</p>
                                    <ul>
                                        <li>user should have firsthand experience with the person/entity being reviewed</li>
                                        <li>user reviews should not contain offensive profanity, or abusive, racist, offensive, or hate language</li>
                                        <li>user reviews should not contain discriminatory references based on religion, race, gender, national origin, age, marital status, sexual orientation, or disability;
                                        </li>
                                        <li>user reviews should not contain references to illegal activity;
                                        </li>
                                        <li>user should not be affiliated with competitors if posting negative reviews;</li>
                                        <li>user should not make any conclusions as to the legality of conduct;</li>
                                        <li>user may not post any false or misleading statements;</li>
                                        <li>user may not organize a campaign encouraging others to post reviews, whether positive or negative.</li>


                                    </ul>

                                    <p>We may accept, reject, or remove reviews in our sole discretion. We have absolutely no obligation to screen reviews or to delete reviews, even if anyone considers reviews objectionable or inaccurate. Reviews are not endorsed by us, and do not necessarily represent our opinions or the views of any of our affiliates or partners. </p>
                                    <p>We do not assume liability for any review or for any claims, liabilities, or losses resulting from any review. By posting a review, user hereby grant to us a perpetual, non-exclusive, worldwide, royalty-free, fully-paid, assignable, and sublicensable right and license to reproduce, modify, translate, transmit by any means, display, perform, and/or distribute all content relating to reviews.</p>

                                    <h1>SOCIAL MEDIA</h1>
                                    <p>As part of the functionality of the Site, user may link user account with online
                                        accounts user have with third-party service providers (each such account, a “Third-Party
                                        Account”) by either:
                                    </p>
                                    <ol>
                                        <li>providing user Third-Party Account login information through the Site; or</li>
                                        <li>allowing us to access user Third-Party Account, as is permitted under the applicable
                                            terms and conditions that govern user use of each Third-Party Account. </li>

                                    </ol>
                                    <p>User represent and warrant that user are entitled to disclose user Third-Party Account login information to us and/or grant us access to user Third-Party Account, without breach by user of any of the terms and conditions that govern user use of the applicable Third-Party Account, and without obligating us to pay any fees or making us subject to any usage limitations imposed by the third-party service provider of the Third-Party Account. </p>
                                    <p>By granting us access to any Third-Party Accounts, user understand that </p>
                                    <ol>
                                        <li>we may access, make available, and store (if applicable) any content that user have provided to and stored in user Third-Party Account (the “Social Network Content”) so that it is available on and through the Site via user account, including without limitation any friend lists and </li>
                                        <li> we may submit to and receive from user Third-Party Account additional information to the extent user are notified when user link user account with the Third-Party Account. </li>
                                    </ol>
                                    <p>Depending on the Third-Party Accounts user choose and subject to the privacy settings that user have set in such Third-Party Accounts, personally identifiable information that user post to user Third-Party Accounts may be available on and through user account on the Site. </p>
                                    <p>Please note that if a Third-Party Account or associated service becomes unavailable or our access to such Third-Party Account is terminated by the third-party service provider, then Social Network Content may no longer be available on and through the Site. User will have the ability to disable the connection between user account on the Site and user Third-Party Accounts at any time.</p>
                                    <p>PLEASE NOTE THAT USER RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED WITH USER THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY USER AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE PROVIDERS.</p>
                                    <p>We make no effort to review any Social Network Content for any purpose, including but not limited to, for accuracy, legality, or non-infringement, and we are not responsible for any Social Network Content. </p>
                                    <p>User acknowledge and agree that we may access user email address book associated with a Third-Party Account and user contacts list stored on user mobile device or tablet computer solely for purposes of identifying and informing user of those contacts who have also registered to use the Site</p>
                                    <p>User can deactivate the connection between the Site and user Third-Party Account by contacting us using the contact information below or through user account settings (if applicable). We will attempt to delete any information stored on our servers that was obtained through such Third-Party Accounts, except the username and profile picture that become associated with user account.</p>



                                </div>


                            </div>

                        </div>
                    </div>
                </div>
            </div >



        </>
    );
};

export default InsBooking;